<template>
  <div class="page-col">
    <div class="page-main">
      <!-- Header Premium -->
      <div class="list-header-premium d-flex flex-column flex-md-row align-items-center justify-content-between gap-3 p-0 mb-3" :class="{'bg-dark border-secondary': isDark}">
        <div class="d-flex align-items-center p-3 flex-shrink-0">
          <div class="header-icon-wrapper mr-3 ml-2" style="background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);">
            <i class="fa fa-list-alt text-white"></i>
          </div>
          <div class="header-text-container">
            <h4 class="mb-0 font-weight-bold" :class="isDark ? 'text-white' : 'text-dark'">Ordem de Abate</h4>
            <p class="text-muted mb-0 small d-none d-lg-block">Pesquisa e gestão de ordens de abate</p>
          </div>
        </div>

        <div class="d-flex align-items-center flex-wrap gap-2 p-3 w-100 w-md-auto justify-content-end">
            <!-- Search Pill -->
            <div class="search-pill-responsive d-flex align-items-center bg-light rounded-pill p-1 shadow-xs border mr-2">
                <b-button-group class="mr-2 d-none d-lg-inline-flex">
                    <b-button variant="link" class="btn-icon-only text-muted" @click="filtro.avancado = !filtro.avancado" v-b-tooltip.hover title="Filtros Avançados">
                        <i class="fa fa-filter" :class="{'text-primary': filtro.avancado}"></i>
                    </b-button>
                    <b-button variant="link" class="btn-icon-only text-muted" @click="exportarExcel()" v-b-tooltip.hover title="Exportar Excel">
                        <i class="fa fa-file-excel-o"></i>
                    </b-button>
                    <b-button variant="link" class="btn-icon-only text-muted" @click="exportarHtml()" v-b-tooltip.hover title="Imprimir/HTML">
                        <i class="fa fa-print"></i>
                    </b-button>
                    <b-button variant="link" class="btn-icon-only text-muted" @click="exportarCsv()" v-b-tooltip.hover title="Exportar CSV">
                        <i class="fa fa-file-text-o"></i>
                    </b-button>
                    <b-button variant="link" class="btn-icon-only text-primary" @click="abrirModalBoletim()" v-b-tooltip.hover title="Boletim de Abate Diário">
                        <i class="fa fa-calendar-check-o"></i>
                    </b-button>
                    <b-button variant="link" class="btn-icon-only text-danger" @click="limpar()" v-b-tooltip.hover title="Limpar Filtros">
                        <i class="fa fa-ban"></i>
                    </b-button>
                </b-button-group>

                <b-button-group class="mr-2 d-lg-none">
                    <b-button variant="link" class="btn-icon-only text-muted" @click="filtro.avancado = !filtro.avancado" v-b-tooltip.hover title="Filtros">
                        <i class="fa fa-filter" :class="{'text-primary': filtro.avancado}"></i>
                    </b-button>
                    <b-button variant="link" class="btn-icon-only text-danger" @click="limpar()" v-b-tooltip.hover title="Limpar">
                        <i class="fa fa-ban"></i>
                    </b-button>
                </b-button-group>

                <div class="d-flex align-items-center px-2 border-left mr-2 date-inputs-responsive">
                    <cec-input-data ref="edDT1" v-model="dt1" class="mx-1" input-class="border-0 bg-transparent" style="width: 150px" @keydown.enter.native="pesquisar()" />
                    <span class="text-muted mx-1 d-none d-sm-inline">até</span>
                    <cec-input-data v-model="dt2" class="mx-1" input-class="border-0 bg-transparent" style="width: 150px" @keydown.enter.native="pesquisar()" />
                </div>
                <b-button variant="primary" pill class="px-4 font-weight-bold shadow-sm text-white btn-filtrar-responsive" :disabled="isBusy" @click="pesquisar()">
                    <i class="fa fa-search mr-1"></i> <span class="d-none d-sm-inline">FILTRAR</span>
                </b-button>
            </div>

            <!-- Action Buttons -->
            <b-button variant="success" pill class="px-4 font-weight-bold shadow-sm btn-adicionar-responsive" @click.stop.prevent="novo()">
              <i class="fa fa-plus-circle mr-2"></i>
              <span class="d-none d-sm-inline">Adicionar</span>
            </b-button>
        </div>
      </div>

      <!-- Advanced Filter Panel -->
      <b-collapse v-model="filtro.avancado">
          <div class="px-4 pb-4">
              <div class="card card-filter-premium compact-filter p-3 border-0 shadow-sm">
                  <b-row>
                    <b-col md="2">
                      <label class="font-weight-bold text-muted small">ID - Ordem</label>
                      <b-form-input size="sm" type="text" v-model="id" placeholder="Número do Pedido" class="custom-input-premium" @keydown.enter.native="pesquisar()"></b-form-input>
                    </b-col>
                    <b-col md="2">
                      <label class="font-weight-bold text-muted small">GTA</label>
                      <b-form-input size="sm" type="text" v-model="gta" placeholder="Número de Controle" class="custom-input-premium" @keydown.enter.native="pesquisar()"></b-form-input>
                    </b-col>
                    <b-col md="2">
                      <label class="font-weight-bold text-muted small">Processo</label>
                      <b-form-select size="sm" v-model="tipoProcesso" :options="optionsTipoProcesso" class="custom-input-premium" @keydown.enter.native="pesquisar()"></b-form-select>
                    </b-col>
                    <b-col md="6">
                      <cliente-pesquisa 
                        @retornaId="clienteId = $event"
                        :idInicial="clienteId"
                        label="Fornecedor"
                        place="Fornecedor Opcional"
                        labelBotao=""
                        ref="clientepesquisa"
                        idModal="clientepesquisa"
                        class="cliente-pesquisa-wrapper"
                        :arredondado="true"
                      />
                    </b-col>
                  </b-row>
                  <b-row class="mt-2">
                    <b-col md="6">
                      <cliente-pesquisa 
                        @retornaId="marchanteId = $event"
                        :idInicial="marchanteId"
                        label="Marchante"
                        place="Marchant Opcional"
                        labelBotao=""
                        ref="marchantpesquisa"
                        idModal="marchantpesquisa"
                        class="cliente-pesquisa-wrapper"
                        :arredondado="true"
                      />
                    </b-col>
                    <b-col md="6">
                      <cliente-pesquisa 
                        @retornaId="fazendaId = $event"
                        :idInicial="fazendaId"
                        label="Fazenda"
                        place="Fazenda Opcional"
                        labelBotao=""
                        ref="fazendapesquisa"
                        idModal="fazendapesquisa"
                        class="cliente-pesquisa-wrapper"
                        :arredondado="true"
                      />
                    </b-col>
                  </b-row>
                  <b-row class="mt-2">
                    <b-col md="12">
                      <label class="font-weight-bold text-muted small d-block mb-1">Situações</label>
                      <b-form-checkbox-group
                        v-model="tipoStatus"
                        :options="statusOptions"
                        switches
                        class="custom-switch-premium"
                      ></b-form-checkbox-group>
                    </b-col>
                  </b-row>
              </div>
          </div>
      </b-collapse>
    
      <!--/.row-->
      <b-row class="ml-0 mr-0 p-0">
        <b-col sm="12" class="p-0">
           
          <b-table 
                  class="modern-premium-table"
                  id="table-transition-example"
                  ref="tbl"
                  :busy.sync="isBusy" 
                  :items="itensFiltrados" 
                  :fields="fields"
                  :current-page="currentPage"
                  :per-page="perPage"
                  :filter="filter"
                  @row-clicked="carregarDetalhes"
                  @row-dblclicked="onEdit"
                  :sticky-header="stickyHeight"
                  :tbody-tr-class="rowClassSelecionado"
                  :dark="isDark"
                  hover 
                  small 
                  show-empty
                  empty-text="Informe o filtro para ver os registros "
                  responsive 
                  >
              <template #custom-foot="{ fields }">
                <b-tr class="bg-white">
                  <b-td class="border-0"></b-td>
                  <b-td v-for="(field, idx) in fields.slice(1)" :key="idx" :class="['border-0', field.key === 'LOTE' ? 'text-left' : 'text-right', 'font-weight-bold']">
                    <span v-if="field.key === 'LOTE'">Itens: ({{ lista.length }})</span>
                    <span v-if="field.key === 'ANIMAIS'">{{ totalCabecas }}</span>
                    <span v-if="field.key === 'QUANT'">{{ totalPeso.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3}) }}</span>
                  </b-td>
                </b-tr>
              </template>

              <template #head(ID)>
                <SetFilter
                  label="Id"
                  v-model="filtros.ID"
                  :options="opcoes.ID"
                  :normalizeFn="normalize"
                  :dropdown-variant="isDark ? 'dark' : 'none'"
                />
              </template>

              <template #head(LOTE)>
                <SetFilter
                  label="Lote"
                  v-model="filtros.LOTE"
                  :options="opcoes.LOTE"
                  :normalizeFn="normalize"
                  :dropdown-variant="isDark ? 'dark' : 'none'"
                />
              </template>

              <template #head(NOME_FORNECEDOR)>
                <SetFilter
                  label="Fornecedor"
                  v-model="filtros.NOME_FORNECEDOR"
                  :options="opcoes.NOME_FORNECEDOR"
                  :normalizeFn="normalize"
                  :dropdown-variant="isDark ? 'dark' : 'none'"
                />
              </template>

              <template #head(STATUS)>
                <SetFilter
                  label="Status"
                  v-model="filtros.STATUS"
                  :options="opcoes.STATUS"
                  :normalizeFn="normalize"
                  :dropdown-variant="isDark ? 'dark' : 'none'"
                />
              </template>

              

              <template #head(TIPO_SERVICO_TRADUZIDO)>
                <SetFilter
                  label="Processo"
                  v-model="filtros.TIPO_SERVICO_TRADUZIDO"
                  :options="opcoes.TIPO_SERVICO_TRADUZIDO"
                  :normalizeFn="normalize"
                  :dropdown-variant="isDark ? 'dark' : 'none'"
                />
              </template>
              <template #head(OP_COMPRADO)>
                <SetFilter
                  label="Comprado"
                  v-model="filtros.OP_COMPRADO"
                  :options="opcoes.OP_COMPRADO"
                  :normalizeFn="normalize"
                  :dropdown-variant="isDark ? 'dark' : 'none'"
                />
              </template>

              <template #head(OP_FECHADO_DIARIO)>
                <SetFilter
                  label="Miúdo"
                  v-model="filtros.OP_FECHADO_DIARIO"
                  :options="opcoes.OP_FECHADO_DIARIO"
                  :normalizeFn="normalize"
                  :dropdown-variant="isDark ? 'dark' : 'none'"
                />
              </template>

              <template #head(EXISTE_PLANO)>
                <SetFilter
                  label="PE"
                  v-model="filtros.EXISTE_PLANO"
                  :options="opcoes.EXISTE_PLANO"
                  :normalizeFn="normalize"
                  :dropdown-variant="isDark ? 'dark' : 'none'"
                />
              </template>

              <template #head(DT_LOTE)>
                <SetFilter
                  label="Data"
                  v-model="filtros.DT_LOTE"
                  :options="opcoes.DT_LOTE"
                  :normalizeFn="normalize"
                  :dropdown-variant="isDark ? 'dark' : 'none'"
                />
              </template>

              <template #head(BOI_PECAS)>
                <SetFilter
                  label="Tipos"
                  v-model="filtros.BOI_PECAS"
                  :options="opcoes.BOI_PECAS"
                  :normalizeFn="normalize"
                  :dropdown-variant="isDark ? 'dark' : 'none'"
                />
              </template>

              <template #head(ANIMAIS)>
                <SetFilter
                  label="Cabeças"
                  v-model="filtros.ANIMAIS"
                  :options="opcoes.ANIMAIS"
                  :normalizeFn="normalize"
                  :dropdown-variant="isDark ? 'dark' : 'none'"
                />
              </template>

              <template #head(QUANT)>
                <SetFilter
                  label="Peso KG"
                  v-model="filtros.QUANT"
                  :options="opcoes.QUANT"
                  :normalizeFn="normalize"
                  :dropdown-variant="isDark ? 'dark' : 'none'"
                />
              </template>

              <template #cell(STATUS)="item">
                <b-badge pill :variant="colorirStatus(item.item.OP_STATUS)">{{traduzirStatus(item.item.OP_STATUS)}}</b-badge>
              </template>
              <template #cell(OP_COMPRADO)="item">
                <b-badge pill :variant="colorirOpComprado(item.item.OP_COMPRADO)">{{traduzirOpComprado(item.item.OP_COMPRADO)}}</b-badge>
              </template>
              <template #cell(TIPO_SERVICO_TRADUZIDO)="item">
                <b-badge pill :variant="colorirTipoServico(item.item.OP_TIPO_SERVICO)">{{item.item.TIPO_SERVICO_TRADUZIDO}}</b-badge>
              </template>      
              <template #cell(EXISTE_PLANO)="item" >
                <i v-if="item.item.EXISTE_PLANO == '1'" :class="'fa fa-check-circle-o ' + colorirExistePlano(item.item.EXISTE_PLANO) "  ></i>
                <i v-else :class="'fa fa-circle-o ' + colorirExistePlano(item.item.EXISTE_PLANO) "  ></i>
              </template>      
              <template #cell(OP_FECHADO_DIARIO)="item" >
                <i v-if="item.item.OP_FECHADO_DIARIO == '1'" :class="'fa fa-check-circle-o ' + colorirFechadoDiario(item.item.OP_FECHADO_DIARIO) "  ></i>
                <i v-else :class="'fa fa-circle-o ' + colorirFechadoDiario(item.item.OP_FECHADO_DIARIO) "  ></i>
              </template>      
              <template #cell(NOME_FORNECEDOR)="item" >
                <span>{{ item.item.NOME_FORNECEDOR }} - {{ item.item.CLIENTE_ID }}</span>
                <div class="small text-muted">FAZENDA: {{ item.item.NOME_FAZENDA }}</div>
              </template>
              <template #cell(BOI_PECAS)="item" >
                <span v-if="item.item.BOI_PECAS > 0">BOI:               <b-badge pill variant="info">{{item.item.BOI_PECAS}}</b-badge> </span>
                <span v-if="item.item.VACA_PECAS > 0">VACA:             <b-badge pill variant="info">{{item.item.VACA_PECAS}}</b-badge> </span>
                <span v-if="item.item.TOURO_PECAS > 0">TOURO:           <b-badge pill variant="info">{{item.item.TOURO_PECAS}}</b-badge></span>
                <span v-if="item.item.NOVILHA_PECAS > 0">NOVI:          <b-badge pill variant="info">{{item.item.NOVILHA_PECAS}}</b-badge></span>
                <span v-if="item.item.BOI_CAPAO > 0">CAPAO:             <b-badge pill variant="info">{{item.item.BOI_CAPAO}}</b-badge></span>
                <span v-if="item.item.BOI_INTEIRO > 0">INT:             <b-badge pill variant="info">{{item.item.BOI_INTEIRO}}</b-badge></span>
                <span v-if="item.item.BUFALO_MACHO_PECAS > 0">B. MACHO: <b-badge pill variant="info">{{item.item.BUFALO_MACHO_PECAS}}</b-badge></span>
                <span v-if="item.item.BUFALO_FEMEA_PECAS > 0">B. FEMEA: <b-badge pill variant="info">{{item.item.BUFALO_FEMEA_PECAS}}</b-badge></span>
              </template>      
              
              <template #cell(actions)="item">
                <div class="d-flex align-items-center gap-1 justify-content-end">
                  <b-button type="button" @click.stop.prevent="onDetalhes(item.item)" variant="soft-info" pill class="btn-icon-only shadow-sm" title="Mais Detalhes" v-b-tooltip.hover>
                    <i class="fa fa-info"></i> 
                  </b-button>
                  <b-button v-if="item.item.OP_STATUS && item.item.OP_STATUS  == '2'" type="button" @click="onSetarLiberarColeta(item.item)" variant="soft-success" pill class="btn-icon-only shadow-sm" title="Liberar para Coleta" v-b-tooltip.hover>
                    <i class="fa fa-check"></i> 
                  </b-button>
                  <b-button v-if="item.item.OP_STATUS && (item.item.OP_STATUS  === '5' )" type="button" @click="abrirModalFechamento(item.item)" variant="soft-info" pill class="btn-icon-only shadow-sm" title="Fechamento da Ordem" v-b-tooltip.hover>
                    <i class="fa fa-check"></i>
                  </b-button>
                  <b-button v-if="item.item.OP_TIPO_SERVICO === '1' && (item.item.OP_STATUS  === '6' )" type="button" @click.stop.prevent="abrirModalCompraAnimais(item.item)" variant="soft-warning" pill class="btn-icon-only shadow-sm" title="Compra de Animais / Precificação" v-b-tooltip.hover>
                    <i class="fa fa-shopping-cart"></i> 
                  </b-button>
                  <b-button v-if="item.item.OP_TIPO_SERVICO === '2' && item.item.OP_STATUS === '6'" type="button" variant="soft-primary" pill class="btn-icon-only shadow-sm" title="Plano de Expedição" v-b-tooltip.hover @click.stop.prevent="abrirModalPlanoExpedicao(item.item)">
                    <i class="fa fa-sign-out"></i> 
                  </b-button>
                  <b-button v-if="item.item.OP_STATUS != '1'" type="button" @click.stop.prevent="imprimir(item.item.ID)" variant="soft-secondary" pill class="btn-icon-only shadow-sm" title="Re-imprimir" v-b-tooltip.hover>
                    <i class="fa fa-print"></i>
                  </b-button>
                  <b-button type="button" @click="abrirModalUpload(item.item)" :variant="'soft-' + colorirBotaoUpload(item.item)" pill class="btn-icon-only shadow-sm" title="Foto ou Imagem" v-b-tooltip.hover>
                    <i class="fa fa-file-image-o"></i> 
                  </b-button>
                  <b-button v-if="item.item.OP_STATUS != '0' || item.item.OP_STATUS  === '1'" type="button" @click="abrirModalCancelamento(item.item)" variant="soft-danger" pill class="btn-icon-only shadow-sm" title="Excluir Ordem" v-b-tooltip.hover>
                    <i class="fa fa-close"></i>
                  </b-button>
                </div>
              </template>

              <template #row-details="row">
                <b-card no-body class="border-0 shadow-sm overflow-hidden m-2">
                  <div class="card-header bg-dark text-white d-flex justify-content-between align-items-center py-1 px-3">
                    <div class="d-flex align-items-center">
                      <i class="fa fa-info-circle mr-2 text-info"></i>
                      <span class="font-weight-bold small">Detalhes da Ordem #{{ row.item.ID }}</span>
                    </div>
                    <b-button variant="link" class="text-white p-0" @click="row.toggleDetails">
                      <i class="fa fa-times"></i>
                    </b-button>
                  </div>
                  <b-card-body class="p-2 bg-light">
                    <b-overlay :show="detalhes.loading" rounded="sm" opacity="0.6" variant="white">
                      <b-row>
                        <!-- Tabela Animais na Ordem -->
                        <b-col lg="5">
                          <div class="detail-card h-100 bg-white rounded shadow-sm border">
                            <div class="p-2 border-bottom bg-soft-info d-flex align-items-center">
                              <i class="fa fa-paw mr-2 text-primary"></i>
                              <h6 class="mb-0 font-weight-bold text-primary small">Animais na Ordem de Abate</h6>
                            </div>
                            <b-table 
                              small 
                              hover 
                              responsive 
                              class="mb-0 modern-premium-table compact"
                              :items="detalhes.animais.items" 
                              :fields="detalhes.animais.fields"
                              show-empty
                              empty-text="Nenhum animal vinculado"
                            ></b-table>
                          </div>
                        </b-col>

                        <!-- Tabela Resumo do Abate -->
                        <b-col lg="7">
                          <div class="detail-card h-100 bg-white rounded shadow-sm border">
                            <div class="p-2 border-bottom bg-soft-success d-flex align-items-center">
                              <i class="fa fa-calculator mr-2 text-success"></i>
                              <h6 class="mb-0 font-weight-bold text-success small">Resumo do Abate</h6>
                            </div>
                            <b-table 
                              small 
                              hover 
                              responsive 
                              class="mb-0 modern-premium-table compact"
                              :items="detalhes.resumo.items" 
                              :fields="detalhes.resumo.fields"
                              show-empty
                              empty-text="Nenhum resumo disponível"
                            ></b-table>
                          </div>
                        </b-col>
                      </b-row>
                    </b-overlay>
                  </b-card-body>
                </b-card>
              </template>
            </b-table>
            
        </b-col>
      </b-row>

      <!--  -----------------------------------------------------------------------------------
                                              MODAL FECHAMENTO
                ----------------------------------------------------------------------------------- -->
      <b-modal ref="modal-fechamento" 
          id="modal-fechamento" 
          hide-header
          hide-footer
          centered
          size="lg"
          body-class="p-0 overflow-hidden"
          content-class="border-0 shadow-lg"
          @shown="focusModalFechamento()" 
      >
        <div class="modal-header-premium p-3 d-flex align-items-center bg-dark" style="background: linear-gradient(135deg, #2c3e50 0%, #000000 100%) !important;">
            <div class="header-icon-wrapper mr-3 bg-white-10">
                <i class="fa fa-align-justify text-white"></i>
            </div>
            <div>
                <h5 class="mb-0 font-weight-bold text-white">Fechamento da Ordem de Abate</h5>
                <small class="text-white opacity-75">Finalização e geração de títulos financeiros</small>
            </div>
            <b-button variant="link" class="ml-auto text-white p-0 opacity-75" @click="$bvModal.hide('modal-fechamento')">
                <i class="fa fa-times fa-lg"></i>
            </b-button>
        </div>

        <div class="p-4 bg-white">
            <div class="modal-info-bar mb-4 p-3 rounded d-flex align-items-center justify-content-between bg-light border">
                <div class="d-flex align-items-center">
                    <div class="avatar-circle mr-3 bg-primary text-white">
                        <i class="fa fa-user"></i>
                    </div>
                    <div>
                        <small class="text-muted d-block">Fornecedor</small>
                        <span class="font-weight-bold text-dark">{{registro.CLIENTE_ID}}</span>
                    </div>
                </div>
                <div class="text-right">
                    <small class="text-muted d-block">ID / Lote</small>
                    <span class="badge badge-dark px-3">{{registro.ID}} - {{registro.LOTE}}</span>
                </div>
            </div>

            <b-row>
              <b-col sm="12">
                <cliente-pesquisa 
                    @retornaId="registro.CLIENTE_ID = $event"
                    :idInicial="registro.CLIENTE_ID"
                    :desabilitarInput="true"
                    id="edCLIENTE_ID"
                    idModal="modalCliente"
                    label="Fornecedor"
                    place="Informe o Fornecedor"
                    labelBotao="">
                </cliente-pesquisa>
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col sm="12">
                <cliente-pesquisa 
                  @retornaId="registro.MARCHANT_ID = $event"
                  :idInicial="registro.MARCHANT_ID"
                  :desabilitarInput="true"
                  idModal="modalMarchant"
                  label="Marchante"
                  id="edMARCHANT_ID"
                  place="Informe o Marchant"
                  labelBotao="">
                </cliente-pesquisa>
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col sm="12">
                <cliente-pesquisa 
                    @retornaId="registro.FAZENDA_ID = $event"
                    :idInicial="registro.FAZENDA_ID"
                    :desabilitarInput="true"
                    idModal="modalFazenda"
                    label="Fazenda"
                    id="edFAZENDA_ID"
                    place="Informe a Fazenda"
                    labelBotao="">
                </cliente-pesquisa>
              </b-col>
            </b-row> 
            
            <hr class="my-4">
            
            <b-row>
              <b-col sm="6">
                <b-form-group label="Gerar Título ao:" label-class="modal-label-premium">
                  <b-form-select  :plain="true" 
                                  id="comboGerarTitulo"
                                  ref="comboGerarTitulo"
                                  :state="registro.OP_DEVEDOR != null"
                                  v-model="registro.OP_DEVEDOR"
                                  :options="tipoGerarTitulo"
                                  class="custom-input-premium">
                    </b-form-select>
                </b-form-group>
              </b-col>
              <b-col sm="6" v-if="registro.campos.DT_VENCIMENTO_ARECEBER == true">
                <b-form-group label="Data Vencimento" label-class="modal-label-premium">
                  <cec-input-data id="edDT_VENCIMENTO_ARECEBER"  
                          :state="registro.DT_VENCIMENTO_ARECEBER ? true : null"
                          v-model="registro.DT_VENCIMENTO_ARECEBER" class="custom-input-premium"> </cec-input-data>
                </b-form-group>
              </b-col>  
            </b-row>

            <b-row v-if="registro.campos.VL_SERVICO_CABECA == true" class="mt-2">
              <b-col sm="4">
                <b-form-group label="Serviço por Cabeça:" label-class="modal-label-premium">
                  <vue-autonumeric  v-model="registro.VL_SERVICO_CABECA" 
                          :options="'Brazilian'" 
                          class="form-control custom-input-premium text-right font-weight-bold"  
                          :class="{
                            'is-valid' : registro.VL_SERVICO_CABECA && registro.VL_SERVICO_CABECA > 0.00,
                            'is-invalid' : !registro.VL_SERVICO_CABECA || registro.VL_SERVICO_CABECA <= 0.00
                          }">
                  </vue-autonumeric>
                </b-form-group>
              </b-col>
              <b-col sm="4">
                <b-form-group label="Cabeças:" label-class="modal-label-premium">
                  <b-form-input  type="text" id="edNR_CABECAS"  
                          :disabled="true"
                          v-model="registro.NR_CABECAS" class="custom-input-premium text-right"> </b-form-input>
                </b-form-group>
              </b-col>
              <b-col sm="4">
                <b-form-group label="Total do Serviço:" label-class="modal-label-premium">
                  <vue-autonumeric  v-model="registro.VL_TOTAL_SERVICO" 
                          :options="'Brazilian'" 
                          :disabled="true"
                          :state="registro.VL_TOTAL_SERVICO && parseFloat(registro.VL_TOTAL_SERVICO) > 0 ? true : null"
                          class="form-control custom-input-premium text-right font-weight-bold bg-light"  >
                  </vue-autonumeric>
                </b-form-group>
              </b-col>
            </b-row>

            <hr class="my-4">

            <b-row>
              <b-col sm="6" v-show="registro.campos.HISTORICO_ARECEBER_ID == true">
                <b-form-group label="Histórico - Caixa" label-class="modal-label-premium">
                    <HistoricoDropDown
                                    id="comboHistorico"
                                    v-model="registro.HISTORICO_ARECEBER_ID" 
                                    tipo="CREDITO"
                                    :state="registro.HISTORICO_ARECEBER_ID != null"
                                    ref="combohistorico"
                                    input-class="custom-input-premium"
                                    placeholder="Selecione o histórico">
                    </HistoricoDropDown>
                </b-form-group>
              </b-col>
              <b-col sm="6" v-show="registro.campos.CENTRO_CUSTO_ARECEBER_ID == true">
                <b-form-group label="Centro de Custo" label-class="modal-label-premium">
                    <CentroCustoDropDown
                                    id="comboCentroCusto"
                                    v-model="registro.CENTRO_CUSTO_ARECEBER_ID" 
                                    :state="registro.CENTRO_CUSTO_ARECEBER_ID != null"
                                    ref="comboCentroCusto"
                                    input-class="custom-input-premium"
                                    placeholder="Selecione o centro de custo">
                    </CentroCustoDropDown>
                </b-form-group>
              </b-col>
            </b-row>
        </div>

        <div class="modal-footer-premium p-3 bg-light border-top d-flex justify-content-end">
          <b-button variant="success" pill class="px-4 font-weight-bold mr-2" @click="onFechamento()">
            <i class="fa fa-check mr-1"></i> FINALIZAR FECHAMENTO
          </b-button>
          <b-button variant="soft-danger" pill class="px-4 font-weight-bold" @click="$bvModal.hide('modal-fechamento')">
            <i class="fa fa-times mr-1"></i> FECHAR
          </b-button>
        </div>
      </b-modal>

      <!--  -----------------------------------------------------------------------------------
                                              MODAL FECHAMENTO PRÓPRIO
                ----------------------------------------------------------------------------------- -->
      <b-modal ref="modal-fechamento-proprio" 
          id="modal-fechamento-proprio" 
          hide-header
          hide-footer
          centered
          size="lg"
          body-class="p-0 overflow-hidden"
          content-class="border-0 shadow-lg"
      >
        <div class="modal-header-premium p-3 d-flex align-items-center bg-dark" style="background: linear-gradient(135deg, #16a085 0%, #0e6e5c 100%) !important;">
            <div class="header-icon-wrapper mr-3 bg-white-10">
                <i class="fa fa-check-circle text-white"></i>
            </div>
            <div>
                <h5 class="mb-0 font-weight-bold text-white">Fechamento da Ordem de Abate - Processo Próprio</h5>
                <small class="text-white opacity-75">Confirmação de fechamento da ordem</small>
            </div>
            <b-button variant="link" class="ml-auto text-white p-0 opacity-75" @click="$bvModal.hide('modal-fechamento-proprio')">
                <i class="fa fa-times fa-lg"></i>
            </b-button>
        </div>

        <div class="p-4 bg-white">
            <div class="alert alert-info d-flex align-items-center mb-4" role="alert">
                <i class="fa fa-info-circle fa-2x mr-3"></i>
                <div>
                    <strong>Atenção!</strong> Você está prestes a fechar uma ordem de abate de processo próprio. Esta ação não pode ser desfeita.
                </div>
            </div>

            <div class="modal-info-bar mb-4 p-3 rounded d-flex align-items-center justify-content-between bg-light border">
                <div class="d-flex align-items-center">
                    <div class="avatar-circle mr-3 bg-success text-white">
                        <i class="fa fa-user"></i>
                    </div>
                    <div>
                        <small class="text-muted d-block">Fornecedor</small>
                        <span class="font-weight-bold text-dark">{{registro.CLIENTE_ID}} - {{registro.NOME_CLIENTE}}</span>
                    </div>
                </div>
                <div class="text-right">
                    <small class="text-muted d-block">ID / Lote</small>
                    <span class="badge badge-success px-3">{{registro.ID}} - {{registro.LOTE}}</span>
                </div>
            </div>

            <b-row>
              <b-col sm="6">
                <div class="card border-0 bg-light p-3">
                    <small class="text-muted d-block mb-1">Fornecedor</small>
                    <h6 class="mb-0 font-weight-bold">{{registro.CLIENTE_ID}} - {{registro.NOME_CLIENTE}}</h6>
                </div>
              </b-col>
              <b-col sm="6">
                <div class="card border-0 bg-light p-3">
                    <small class="text-muted d-block mb-1">Fazenda</small>
                    <h6 class="mb-0 font-weight-bold">{{registro.FAZENDA_ID}} - {{registro.NOME_FAZENDA || 'N/A'}}</h6>
                </div>
              </b-col>
            </b-row>

            <b-row class="mt-3">
              <b-col sm="12">
                <div class="card border-0 bg-light p-3">
                    <small class="text-muted d-block mb-1">Marchante</small>
                    <h6 class="mb-0 font-weight-bold">{{registro.MARCHANT_ID || 'N/A'}}</h6>
                </div>
              </b-col>
            </b-row>
        </div>

        <div class="modal-footer-premium p-3 bg-light border-top d-flex justify-content-end">
          <b-button variant="success" pill class="px-4 font-weight-bold mr-2" @click="onConfirmarFechamentoProprio()">
            <i class="fa fa-check mr-1"></i> CONFIRMAR FECHAMENTO
          </b-button>
          <b-button variant="soft-danger" pill class="px-4 font-weight-bold" @click="$bvModal.hide('modal-fechamento-proprio')">
            <i class="fa fa-times mr-1"></i> CANCELAR
          </b-button>
        </div>
      </b-modal>
    </div>
    <div>
      <!--  -----------------------------------------------------------------------------------
                                              MODAL REMOVER ARQUIVO 
                ----------------------------------------------------------------------------------- -->
      <b-modal ref="modal-upload-remove" 
          id="modal-upload-remove" 
          hide-header
          body-class="p-0"
          centered
          size="lg"
          @shown="focusModalRemoveArquivo()" 
          headerClass= "p-2 border-bottom-0" 
          title="REMOVER ARQUIVO DA PESAGEM" >
        <b-card bg-variant="light">
            <div slot="header">
                <i class='fa fa-align-justify'></i><strong>  Remover arquivo da Pesagem</strong>
            </div>
            <b-row class="mb-1">
              <b-col cols="12" md="3">
                <label>Fornecedor:</label>
              </b-col>
              <b-col cols="12" md="8">
                <strong>{{modalUpload.nomeCliente}}</strong>
              </b-col>
            </b-row>
            <b-row class="mb-1">
              <b-col cols="12" md="3">
                <label>Ordem de Abate:</label>
              </b-col>
              <b-col cols="12" md="3">
                <strong>{{modalUpload.loteId}}</strong>
              </b-col>
              <b-col cols="12" md="3">
                <label>Número do Lote:</label>
              </b-col>
              <b-col cols="12" md="3">
                <strong>{{modalUpload.lote}}</strong>
              </b-col>
            </b-row>
           
        </b-card>
        

        <template #modal-footer="{ cancel }">
          <b-button  variant="success" @click="onRemoverArquivo()">
            <i class="fa fa-upload"></i>Remover Arquivo
          </b-button>
          <b-button    variant="danger" @click="cancel()">
            Fechar
          </b-button>
        </template>
      </b-modal>
    </div>
    <div>
      <!--  -----------------------------------------------------------------------------------
                                              MODAL UPLOAD 
                ----------------------------------------------------------------------------------- -->
      <!--  -----------------------------------------------------------------------------------
                                              MODAL UPLOAD 
                ----------------------------------------------------------------------------------- -->
      <b-modal ref="modal-upload" 
          id="modal-upload" 
          hide-header
          hide-footer
          centered
          scrollable 
          size="lg"
          body-class="p-0 overflow-hidden"
          content-class="border-0 shadow-lg"
          @shown="focusModalUpload()" 
      >
        <div class="modal-header-premium p-3 d-flex align-items-center bg-dark" style="background: linear-gradient(135deg, #4a90e2 0%, #1456a3 100%) !important;">
            <div class="header-icon-wrapper mr-3 bg-white-10">
                <i class="fa fa-file-image-o text-white"></i>
            </div>
            <div>
                <h5 class="mb-0 font-weight-bold text-white">Arquivo da Pesagem</h5>
                <small class="text-white opacity-75">Upload e visualização de comprovantes</small>
            </div>
            <b-button variant="link" class="ml-auto text-white p-0 opacity-75" @click="$bvModal.hide('modal-upload')">
                <i class="fa fa-times fa-lg"></i>
            </b-button>
        </div>

        <div class="p-4 bg-white">
            <div class="modal-info-bar mb-4 p-3 rounded d-flex align-items-center justify-content-between bg-light border">
                <div class="d-flex align-items-center">
                    <div class="avatar-circle mr-3 bg-info text-white">
                        <i class="fa fa-user"></i>
                    </div>
                    <div>
                        <small class="text-muted d-block">Fornecedor</small>
                        <span class="font-weight-bold text-dark">{{modalUpload.nomeCliente}}</span>
                    </div>
                </div>
                <div class="text-right">
                    <small class="text-muted d-block">ID / Lote</small>
                    <span class="badge badge-dark px-3">{{modalUpload.loteId}} - {{modalUpload.lote}}</span>
                </div>
            </div>

            <div v-if="modalUpload.imagem == null">
                <b-form-group label="Selecione o Arquivo" label-class="modal-label-premium">
                    <b-form-file
                      accept=".jpeg,.jpg"
                      v-model="modalUpload.file"
                      :state="Boolean(modalUpload.file)"
                      ref="edUpload"
                      placeholder="Escolha um arquivo de Imagem, Foto (Arraste ele pra cá)"
                      drop-placeholder="Arraste o arquivo pra cá..."
                      class="custom-input-premium"
                    ></b-form-file>
                </b-form-group>
            </div>

            <div v-if="modalUpload.imagem != null" class="text-center">
                <div class="mb-3">
                    <b-button variant="soft-danger" pill class="px-4 font-weight-bold" @click.stop.prevent="onRemoverArquivo()">
                        <i class="fa fa-trash mr-1"></i> REMOVER IMAGEM ATUAL
                    </b-button>
                </div>
                <div class="image-preview-container p-2 border rounded bg-light shadow-sm">
                    <b-img :src="'data:image/jpg;base64,'+modalUpload.imagem" fluid alt="Comprovante" class="rounded shadow-xs"></b-img>
                </div>
            </div>
        </div>

        <div class="modal-footer-premium p-3 bg-light border-top d-flex justify-content-end">
          <b-button v-if="modalUpload.imagem == null" variant="success" pill class="px-4 font-weight-bold mr-2" @click="onUpload()">
            <i class="fa fa-upload mr-1"></i> ENVIAR ARQUIVO
          </b-button>
          <b-button variant="soft-danger" pill class="px-4 font-weight-bold" @click="onFecharModalUpload()">
            <i class="fa fa-times mr-1"></i> FECHAR
          </b-button>
        </div>
      </b-modal>
    </div>
    <div>
      <!--  -----------------------------------------------------------------------------------
                                              MODAL CANCELAMENTO 
                ----------------------------------------------------------------------------------- -->
      <b-modal ref="modal-cancelamento" 
          id="modal-cancelamento" 
          hide-header
          hide-footer
          centered
          size="lg"
          body-class="p-0 overflow-hidden"
          content-class="border-0 shadow-lg"
          @shown="focusModalCancelamento()" 
      >
        <div class="modal-header-premium p-3 d-flex align-items-center bg-dark" style="background: linear-gradient(135deg, #e53e3e 0%, #7d1c1c 100%) !important;">
            <div class="header-icon-wrapper mr-3 bg-white-10">
                <i class="fa fa-times-circle text-white"></i>
            </div>
            <div>
                <h5 class="mb-0 font-weight-bold text-white">Cancelar Ordem de Abate</h5>
                <small class="text-white opacity-75">Anulação definitiva do registro</small>
            </div>
            <b-button variant="link" class="ml-auto text-white p-0 opacity-75" @click="$bvModal.hide('modal-cancelamento')">
                <i class="fa fa-times fa-lg"></i>
            </b-button>
        </div>

        <div class="p-4 bg-white">
            <div class="modal-info-bar mb-4 p-3 rounded d-flex align-items-center justify-content-between bg-light border">
                <div class="d-flex align-items-center">
                    <div class="avatar-circle mr-3 bg-danger text-white">
                        <i class="fa fa-user"></i>
                    </div>
                    <div>
                        <small class="text-muted d-block">Fornecedor</small>
                        <span class="font-weight-bold text-dark">{{modalUpload.nomeCliente}}</span>
                    </div>
                </div>
                <div class="text-right">
                    <small class="text-muted d-block">ID / Lote</small>
                    <span class="badge badge-dark px-3">{{modalUpload.loteId}} - {{modalUpload.lote}}</span>
                </div>
            </div>

            <b-form-group label="Motivo do Cancelamento" label-class="modal-label-premium">
                <b-form-input 
                  type="text" 
                  ref="edMotivoCancelamento" 
                  id="edMotivoCancelamento" 
                  placeholder="Informe detalhadamente o motivo..." 
                  :state="Boolean(modalUpload.motivoCancelamento)"
                  v-model="modalUpload.motivoCancelamento"
                  class="custom-input-premium"
                ></b-form-input>
            </b-form-group>
        </div>

        <div class="modal-footer-premium p-3 bg-light border-top d-flex justify-content-end">
          <b-button variant="danger" pill class="px-4 font-weight-bold mr-2" @click="cancelar()">
            <i class="fa fa-check mr-1"></i> CONFIRMAR CANCELAMENTO
          </b-button>
          <b-button variant="soft-secondary" pill class="px-4 font-weight-bold" @click="$bvModal.hide('modal-cancelamento')">
            <i class="fa fa-times mr-1"></i> FECHAR
          </b-button>
        </div>
      </b-modal>
    </div>
    <div>
      <!--  -----------------------------------------------------------------------------------
                                            MODAL INFO 
      ----------------------------------------------------------------------------------- -->
      <b-modal ref="modal-info" 
          id="modal-info" 
          hide-header
          hide-footer
          centered
          size="xl"
          body-class="p-0 overflow-hidden"
          content-class="border-0 shadow-lg"
      >
        <div class="modal-header-premium p-3 d-flex align-items-center bg-dark" style="background: linear-gradient(135deg, #2c3e50 0%, #000000 100%) !important;">
            <div class="header-icon-wrapper mr-3 bg-white-10">
                <i class="fa fa-info text-white"></i>
            </div>
            <div>
                <h5 class="mb-0 font-weight-bold text-white">Itens da Venda</h5>
                <small class="text-white opacity-75">Detalhes técnicos e histórico de alterações</small>
            </div>
            <b-button variant="link" class="ml-auto text-white p-0 opacity-75" @click="$bvModal.hide('modal-info')">
                <i class="fa fa-times fa-lg"></i>
            </b-button>
        </div>

        <div class="p-4 bg-white">
            <div class="modal-info-bar mb-4 p-3 rounded d-flex align-items-center justify-content-between bg-light border">
                <div class="d-flex align-items-center">
                    <div class="avatar-circle mr-3 bg-primary text-white">
                        <i class="fa fa-user"></i>
                    </div>
                    <div>
                        <small class="text-muted d-block">Cliente</small>
                        <span class="font-weight-bold text-dark">{{dadosModalInfo.nomeCliente}}</span>
                    </div>
                </div>
                <div class="text-right">
                    <small class="text-muted d-block">Controle ID / Pedido</small>
                    <span class="badge badge-dark px-3">{{dadosModalInfo.id}} - {{dadosModalInfo.documento}}</span>
                </div>
            </div>

            <div class="row mb-4">
                <div class="col-md-4">
                    <div class="premium-summary-card p-3 rounded border bg-white shadow-xs h-100">
                        <small class="text-muted d-block mb-1">Vendedor</small>
                        <h6 class="mb-0 font-weight-bold text-dark">{{dadosModalInfo.nomeVendedor}}</h6>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="premium-summary-card p-3 rounded border bg-white shadow-xs h-100">
                        <small class="text-muted d-block mb-1">Data Venda</small>
                        <h6 class="mb-0 font-weight-bold text-dark">{{dadosModalInfo.dataVenda}}</h6>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="premium-summary-card p-3 rounded border bg-white shadow-xs h-100">
                        <small class="text-muted d-block mb-1">Valor Total</small>
                        <h6 class="mb-0 font-weight-bold text-success">{{dadosModalInfo.total}}</h6>
                    </div>
                </div>
            </div>

            <b-tabs content-class="mt-3" pills nav-class="custom-pills-premium">
                <b-tab title="Produtos" active>
                    <b-table 
                        class="modern-premium-table"
                        striped 
                        hover 
                        show-empty
                        empty-text="Venda sem Produtos lançados"
                        stacked="md"
                        small
                        responsive 
                        :items="tabelaItens.items" 
                        :fields="tabelaItens.fields">
                    </b-table>
                </b-tab>
                <b-tab title="Histórico">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="card border-0 bg-light p-3 h-100">
                                <h6 class="font-weight-bold text-primary mb-3"><i class="fa fa-edit mr-2"></i>ALTERAÇÃO</h6>
                                <div class="mb-2">
                                    <small class="text-muted d-block">Data / Usuário</small>
                                    <span class="font-weight-bold">{{dadosModalInfo.dataAlteracao}} - {{dadosModalInfo.usuarioAlteracao}}</span>
                                </div>
                                <div>
                                    <small class="text-muted d-block">Motivo</small>
                                    <p class="mb-0 italic">{{dadosModalInfo.motivoAlteracao || 'Não informado'}}</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="card border-0 bg-soft-danger p-3 h-100">
                                <h6 class="font-weight-bold text-danger mb-3"><i class="fa fa-ban mr-2"></i>CANCELAMENTO</h6>
                                <div class="mb-2">
                                    <small class="text-muted d-block">Data / Usuário</small>
                                    <span class="font-weight-bold">{{dadosModalInfo.dataCancelamento}} - {{dadosModalInfo.usuarioCancelamento}}</span>
                                </div>
                                <div>
                                    <small class="text-muted d-block">Motivo</small>
                                    <p class="mb-0 italic">{{dadosModalInfo.motivoCancelamento || 'Não informado'}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </b-tab>
            </b-tabs>
        </div>

        <div class="modal-footer-premium p-3 bg-light border-top d-flex justify-content-end">
          <b-button variant="soft-danger" pill class="px-4 font-weight-bold" @click="$bvModal.hide('modal-info')">
            <i class="fa fa-times mr-1"></i> FECHAR
          </b-button>
        </div>
      </b-modal>
    </div>

    <div>
      <b-modal ref="modal-plano-expedicao"
          id="modal-plano-expedicao"
          hide-header
          hide-footer
          body-class="p-0"
          centered
          size="xl"
          scrollable
          header-class="p-0 border-bottom-0">
        <div class="modal-header-premium p-3 d-flex align-items-center bg-dark" style="background: linear-gradient(135deg, #2c3e50 0%, #000000 100%) !important;">
          <div class="header-icon-wrapper-modal mr-3 bg-white-20">
            <i class="fa fa-sign-out text-white"></i>
          </div>
          <div>
            <h5 class="mb-0 font-weight-bold text-white">Plano de Entrega da Expedição</h5>
            <small class="text-white opacity-75">Marque os Tipos de Produtos que serão entregues na Expedição</small>
          </div>
          <b-button variant="link" class="ml-auto text-white p-0 opacity-75" @click="$bvModal.hide('modal-plano-expedicao')">
              <i class="fa fa-times fa-lg"></i>
          </b-button>
        </div>

        <div class="p-4 bg-white">
          <b-overlay :show="planoExpedicao.busy" rounded="sm">
            <div v-if="planoExpedicao.mensagem" class="text-center text-danger font-weight-bold mb-3 pb-2 border-bottom">
              {{ planoExpedicao.mensagem }}
            </div>
            <div v-if="faltamItensObrigatorios" class="text-center text-warning font-weight-bold mb-3 pb-2 border-bottom">
              <i class="fa fa-exclamation-triangle mr-1"></i> EXISTEM ITENS OBRIGATÓRIOS NÃO MARCADOS!
            </div>

            <b-table
              class="modern-premium-table mb-0"
              :items="planoExpedicao.items"
              :fields="planoExpedicao.fields"
              :tbody-tr-class="rowClassPlanoExpedicao"
              small
              stacked="md"
              responsive
              hover
              show-empty
              empty-text="Nenhum item encontrado"
            >
              <template #cell(MARCA)="row">
                <div class="d-flex align-items-center justify-content-center">
                  <b-form-checkbox
                    switch
                    size="sm"
                    class="mb-0"
                    v-model="row.item.selecionado"
                    :disabled="planoExpedicao.existePedido === true"
                    @change="onMarcaPlanoAlteracao(row.item)"
                  ></b-form-checkbox>
                </div>
              </template>
              <template #cell(PECAS)="row">
                <span class="text-right d-block">{{ Number(row.item.PECAS || 0).toLocaleString('pt-BR', { style: 'decimal', minimumFractionDigits: 2 }) }}</span>
              </template>
            </b-table>

            <b-form-group label="Instruções e Observações" label-class="modal-label-premium" class="mt-4">
              <b-form-textarea
                rows="3"
                max-rows="4"
                placeholder="Informe alguma instrução adicional"
                v-model="planoExpedicao.observacao"
              ></b-form-textarea>
            </b-form-group>
          </b-overlay>
        </div>
        <div class="modal-footer-premium p-3 bg-light border-top d-flex justify-content-end">
          <b-button variant="success" pill class="px-4 font-weight-bold mr-2" :disabled="confirmPlanoExpedicaoDisabled" @click="confirmarPlanoExpedicao()">
            <i class="fa fa-sign-out mr-1"></i> CONFIRMAR
          </b-button>
          <b-button variant="soft-danger" pill class="px-4 font-weight-bold" @click="$bvModal.hide('modal-plano-expedicao')">
            <i class="fa fa-times mr-1"></i> FECHAR
          </b-button>
        </div>
      </b-modal>
    </div>

    <div>
      <!-- Modal Boletim de Abate Diário -->
      <b-modal ref="modal-boletim" 
          id="modal-boletim" 
          hide-header
          hide-footer
          centered
          size="md"
          body-class="p-0 overflow-hidden"
          content-class="border-0 shadow-lg"
      >
        <div class="modal-header-premium p-3 d-flex align-items-center bg-dark" style="background: linear-gradient(135deg, #3a7bd5 0%, #00d2ff 100%) !important;">
            <div class="header-icon-wrapper mr-3 bg-white-10">
                <i class="fa fa-file-text text-white"></i>
            </div>
            <div>
                <h5 class="mb-0 font-weight-bold text-white">Boletim de Abate Diário</h5>
                <small class="text-white opacity-75">BOAD - BOLETIM DE ABATE DIARIO</small>
            </div>
            <b-button variant="link" class="ml-auto text-white p-0 opacity-75" @click="$bvModal.hide('modal-boletim')">
                <i class="fa fa-times fa-lg"></i>
            </b-button>
        </div>

        <div class="p-4 bg-white">
            <p class="text-muted mb-3">Informe o Período</p>
            <b-row align-v="center">
              <b-col sm="4">
                <label class="mb-0 font-weight-bold">Informe o Dia:</label>
              </b-col>
              <b-col sm="8">
                <cec-input-data v-model="modalBoletim.data" :arredondado="true" />
              </b-col>
            </b-row>
        </div>

        <div class="modal-footer-premium p-3 bg-light border-top d-flex justify-content-between">
          <b-button variant="outline-primary" pill class="px-4 font-weight-bold" @click="onVisualizarBoletim()">
            <i class="fa fa-print mr-1"></i> Visualizar
          </b-button>
          <b-button variant="soft-danger" pill class="px-4 font-weight-bold" @click="$bvModal.hide('modal-boletim')">
            <i class="fa fa-times mr-1"></i> Fechar
          </b-button>
        </div>
      </b-modal>
    </div>

    <div>
      <!-- Modal Compra de Animais da Ordem de Abate -->
      <b-modal ref="modal-compra-animais" 
          id="modal-compra-animais" 
          hide-header
          hide-footer
          centered
          size="xl"
          body-class="p-0 overflow-hidden"
          content-class="border-0 shadow-lg"
      >
        <div class="modal-header-premium p-3 d-flex align-items-center bg-dark" style="background: linear-gradient(135deg, #4a90e2 0%, #1456a3 100%) !important;">
            <div class="header-icon-wrapper mr-3 bg-white-10">
                <i class="fa fa-shopping-cart text-white"></i>
            </div>
            <div>
                <h5 class="mb-0 font-weight-bold text-white">COMPRA DE ANIMAIS DA ORDEM DE ABATE</h5>
                <small class="text-white opacity-75">Informações da Compra ou Precificação</small>
            </div>
            <div class="ml-auto d-flex gap-2">
                <b-button v-if="modalCompraAnimais.abate.OP_COMPRADO == null" variant="success" class="px-4 font-weight-bold" @click="onConfirmarCompraAnimais()">
                    <i class="fa fa-shopping-cart mr-1"></i> Comprar
                </b-button>
                <b-button variant="danger" class="px-4 font-weight-bold" @click="$bvModal.hide('modal-compra-animais')">
                    <i class="fa fa-times mr-1"></i> Fechar
                </b-button>
            </div>
        </div>

        <div class="p-3 bg-white">
            <div class="modal-info-bar mb-3 p-3 rounded d-flex align-items-center justify-content-between bg-light border">
                <div class="d-flex align-items-center gap-3">
                     <div class="d-flex align-items-center mr-4">
                        <div class="avatar-circle mr-2 bg-primary text-white" style="width: 40px; height: 40px; font-size: 1.2rem;">
                            <i class="fa fa-shopping-cart"></i>
                        </div>
                        <div>
                            <small class="text-muted d-block">ID Ordem</small>
                            <span class="font-weight-bold text-dark h5 mb-0">{{modalCompraAnimais.abate.ID}}</span>
                        </div>
                    </div>
                    <div class="d-flex align-items-center mr-4">
                        <div class="mr-2 text-primary opacity-50">
                            <i class="fa fa-calendar fa-2x"></i>
                        </div>
                        <div>
                            <small class="text-muted d-block">Data do Abate</small>
                            <span class="font-weight-bold text-dark">{{ modalCompraAnimais.abate.DT_LOTE ? moment(modalCompraAnimais.abate.DT_LOTE).format('DD/MM/YYYY') : '' }}</span>
                        </div>
                    </div>
                    <div class="d-flex align-items-center mr-4">
                        <div class="mr-2 text-info opacity-75">
                            <i class="fa fa-info-circle fa-2x"></i>
                        </div>
                        <div>
                            <small class="text-muted d-block">Status</small>
                            <b-badge :variant="modalCompraAnimais.abate.OP_COMPRADO == null ? 'warning' : modalCompraAnimais.abate.OP_COMPRADO == '1' ? 'info' : modalCompraAnimais.abate.OP_COMPRADO == '2' ? 'primary' : modalCompraAnimais.abate.OP_COMPRADO == '3' ? 'success' : 'dark'" class="font-weight-bold">
                                {{ modalCompraAnimais.abate.OP_COMPRADO == null ? 'NÃO PRECIFICADO' : modalCompraAnimais.abate.OP_COMPRADO == '1' ? 'PRECIFICADO' : modalCompraAnimais.abate.OP_COMPRADO == '2' ? 'NF GERADA' : modalCompraAnimais.abate.OP_COMPRADO == '3' ? 'FINANCEIRO GERADO' : 'NF E FINANCEIRO' }}
                            </b-badge>
                        </div>
                    </div>
                </div>
                 <div class="text-right">
                    <b-badge variant="outline-success" class="px-3 py-2 font-weight-bold" style="font-size: 0.9rem">PREÇO TOTAL: R$ {{ Number(modalCompraAnimais.abate.VL_TOTAL_COMPRA || 0).toLocaleString('pt-BR', {minimumFractionDigits: 2}) }}</b-badge>
                </div>
            </div>

            <b-row class="mb-3">
                <b-col md="8">
                    <div class="card h-100 border-0 shadow-sm">
                         <div class="card-header bg-light py-2 px-3 border-bottom d-flex align-items-center justify-content-between">
                            <span class="font-weight-bold text-uppercase text-primary small"><i class="fa fa-users mr-1"></i> Participantes</span>
                        </div>
                        <div class="card-body p-3">
                            <b-row>
                                <b-col md="6" class="mb-3">
                                    <div class="p-2 border rounded bg-white h-100 relative">
                                        <small class="text-muted text-uppercase font-weight-bold" style="font-size: 0.65rem;">Fornecedor</small>
                                        <div class="d-flex align-items-center mt-1">
                                            <b-badge variant="light" class="mr-2 border text-muted">{{modalCompraAnimais.abate.CLIENTE_ID}}</b-badge>
                                            <span class="text-dark font-weight-bold text-truncate" :title="modalCompraAnimais.fornecedorNome">{{modalCompraAnimais.fornecedorNome || 'Não Identificado'}}</span>
                                        </div>
                                    </div>
                                </b-col>
                                <b-col md="6" class="mb-3">
                                    <div class="p-2 border rounded bg-white h-100 relative">
                                        <small class="text-muted text-uppercase font-weight-bold" style="font-size: 0.65rem;">Marchant</small>
                                        <div class="d-flex align-items-center mt-1">
                                            <b-badge variant="light" class="mr-2 border text-muted">{{modalCompraAnimais.abate.MARCHANT_ID}}</b-badge>
                                            <span class="text-dark font-weight-bold text-truncate" :title="modalCompraAnimais.marchantNome">{{modalCompraAnimais.marchantNome || 'Não Identificado'}}</span>
                                        </div>
                                    </div>
                                </b-col>
                                <b-col md="6">
                                    <div class="p-2 border rounded bg-white h-100 relative">
                                        <small class="text-muted text-uppercase font-weight-bold" style="font-size: 0.65rem;">Fazenda</small>
                                        <div class="d-flex align-items-center mt-1">
                                            <b-badge variant="light" class="mr-2 border text-muted">{{modalCompraAnimais.abate.FAZENDA_ID}}</b-badge>
                                            <span class="text-dark font-weight-bold text-truncate" :title="modalCompraAnimais.fazendaNome">{{modalCompraAnimais.fazendaNome || 'Não Identificado'}}</span>
                                        </div>
                                    </div>
                                </b-col>
                                <b-col md="6">
                                    <div class="p-2 border rounded bg-white h-100 relative">
                                        <small class="text-muted text-uppercase font-weight-bold" style="font-size: 0.65rem;">Transportadora</small>
                                        <div class="d-flex align-items-center mt-1">
                                            <b-badge variant="light" class="mr-2 border text-muted">{{modalCompraAnimais.abate.TRANSPORTADORA_ID}}</b-badge>
                                            <span class="text-dark font-weight-bold text-truncate" :title="modalCompraAnimais.transportadoraNome">{{modalCompraAnimais.transportadoraNome || 'Não Identificado'}}</span>
                                        </div>
                                    </div>
                                </b-col>
                            </b-row>
                        </div>
                    </div>
                </b-col>
                <b-col md="4">
                    <div class="card h-100 border-0 shadow-sm">
                        <div class="card-header bg-light py-2 px-3 border-bottom">
                            <span class="font-weight-bold text-uppercase text-primary small"><i class="fa fa-calculator mr-1"></i> Totais da Compra</span>
                        </div>
                        <div class="card-body p-3">
                            <div class="d-flex justify-content-between align-items-center mb-2 p-2 rounded bg-soft-info">
                                <span class="font-weight-bold text-dark small">TOTAL BRUTO</span>
                                <span class="font-weight-bold text-dark">{{ Number(modalCompraAnimais.abate.VL_TOTAL_BRUTO || 0).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) }}</span>
                            </div>
                            
                            <hr class="my-2 border-0 bg-light" style="height: 1px;">

                            <div class="form-row align-items-center mb-2">
                                <div class="col-8">
                                    <label class="small font-weight-bold text-muted mb-0">FUNRURAL %</label>
                                </div>
                                <div class="col-4">
                                     <vue-autonumeric v-model="modalCompraAnimais.abate.PERCENTUAL_FUNRURAL" :options="'Brazilian'" :disabled="modalCompraAnimais.abate.OP_COMPRADO !== null && modalCompraAnimais.abate.OP_COMPRADO !== '1'" class="form-control form-control-sm text-right" @input="calcularTotaisCompraAnimais()"></vue-autonumeric>
                                </div>
                            </div>
                            
                            <div class="d-flex justify-content-between align-items-center mb-2 px-2">
                                <span class="small text-muted">(-) Funrural R$</span>
                                <span class="text-danger font-weight-bold small">{{ Number(modalCompraAnimais.abate.VL_FUNRURAL || 0).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) }}</span>
                            </div>
                            
                            <b-button
                                v-if="modalCompraAnimais.abate.OP_COMPRADO == '1'"
                                variant="success" 
                                class="d-flex justify-content-between align-items-center mt-3 p-3 rounded text-white shadow-sm w-100 font-weight-bold"
                                @click="onGerarTituloAPagar()"
                                style="border: none;"
                            >
                                <span class="small">GERAR A PAGAR</span>
                                <span class="h5 mb-0">{{ Number(modalCompraAnimais.abate.VL_TOTAL_COMPRA || 0).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) }}</span>
                            </b-button>
                            
                            <div v-if="modalCompraAnimais.abate.OP_COMPRADO != '1'" class="d-flex justify-content-between align-items-center mt-3 p-3 rounded bg-success text-white shadow-sm">
                                <span class="font-weight-bold small">TOTAL A PAGAR</span>
                                <span class="font-weight-bold h5 mb-0">{{ Number(modalCompraAnimais.abate.VL_TOTAL_COMPRA || 0).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) }}</span>
                            </div>
                        </div>
                    </div>
                </b-col>
            </b-row>
            
            <b-row class="mb-3">
                <b-col cols="12">
                     <div class="card border-0 shadow-sm bg-light">
                        <div class="card-body p-3">
                            <b-row align-v="center">
                                <b-col lg="3" md="6" class="mb-2 mb-lg-0">
                                    <label class="small font-weight-bold text-muted mb-1">Comprar de Quem? <span class="text-danger">*</span></label>
                                    <b-form-select size="sm" v-model="modalCompraAnimais.abate.OP_CREDOR" :options="modalCompraAnimais.opcoesCredor" :state="modalCompraAnimais.abate.OP_CREDOR && modalCompraAnimais.abate.OP_CREDOR.trim() !== '' ? true : false" :disabled="modalCompraAnimais.abate.OP_COMPRADO !== null && modalCompraAnimais.abate.OP_COMPRADO !== '1'" class="bg-white"></b-form-select>
                                </b-col>
                                <b-col lg="3" md="6" class="mb-2 mb-lg-0">
                                    <label class="small font-weight-bold text-muted mb-1">Histórico Caixa <span class="text-danger">*</span></label>
                                    <HistoricoDropDown v-model="modalCompraAnimais.abate.HISTORICO_APAGAR_ID" :state="!!modalCompraAnimais.abate.HISTORICO_APAGAR_ID" :disabled="modalCompraAnimais.abate.OP_COMPRADO !== null && modalCompraAnimais.abate.OP_COMPRADO !== '1'" size="sm" class="bg-white" />
                                </b-col>
                                <b-col lg="3" md="6" class="mb-2 mb-lg-0">
                                    <label class="small font-weight-bold text-muted mb-1">Centro de Custo <span class="text-danger">*</span></label>
                                    <CentroCustoDropDown v-model="modalCompraAnimais.abate.CENTRO_CUSTO_APAGAR_ID" :state="!!modalCompraAnimais.abate.CENTRO_CUSTO_APAGAR_ID" :disabled="modalCompraAnimais.abate.OP_COMPRADO !== null && modalCompraAnimais.abate.OP_COMPRADO !== '1'" size="sm" class="bg-white text-uppercase" />
                                </b-col>
                                <b-col lg="3" md="6">
                                     <label class="small font-weight-bold text-muted mb-1">Comprador <span class="text-danger">*</span></label>
                                    <FuncionarioDropDown v-model="modalCompraAnimais.abate.COMPRADOR_ID" :state="!!modalCompraAnimais.abate.COMPRADOR_ID" :disabled="modalCompraAnimais.abate.OP_COMPRADO !== null && modalCompraAnimais.abate.OP_COMPRADO !== '1'" size="sm" class="bg-white" />
                                </b-col>
                            </b-row>
                        </div>
                    </div>
                </b-col>
            </b-row>

            <b-row>
                <b-col md="8">
                    <div class="card border-0 shadow-sm h-100">
                        <div class="card-header bg-light py-1 px-3">
                            <span class="font-weight-bold small text-uppercase">Compra dos Animais</span>
                        </div>
                        <div class="card-body p-0">
                            <b-table 
                                small 
                                hover 
                                responsive 
                                class="mb-0 modern-premium-table compact"
                                :items="modalCompraAnimais.animais" 
                                :fields="modalCompraAnimais.fieldsAnimais"
                                show-empty
                                empty-text="Nenhum animal precificado"
                            >
                                <template #cell(VL_ARROBA)="row">
                                    <vue-autonumeric 
                                        v-model="row.item.VL_ARROBA" 
                                        :options="'Brazilian'" 
                                        :disabled="modalCompraAnimais.abate.OP_COMPRADO !== null && modalCompraAnimais.abate.OP_COMPRADO !== undefined"
                                        :class="{'form-control form-control-sm text-right': true, 'bg-warning-light': modalCompraAnimais.abate.OP_COMPRADO === null, 'is-valid': row.item.VL_ARROBA > 0, 'is-invalid': !row.item.VL_ARROBA || row.item.VL_ARROBA <= 0}"
                                        @input="calcularTotaisCompraAnimais()"
                                    ></vue-autonumeric>
                                </template>
                            </b-table>
                        </div>
                        <div class="card-footer bg-light p-2 d-flex justify-content-between align-items-center">
                            <b-button v-if="modalCompraAnimais.abate.OP_COMPRADO == null || modalCompraAnimais.abate.OP_COMPRADO == '1'" variant="success" size="sm" @click="onGerarResumoAnimais()">
                                <i class="fa fa-th mr-1"></i> Gerar Resumo dos Animais
                            </b-button>
                            <span class="small text-muted italic">Altere o valor da Arroba @ Diretamente na Lista</span>
                        </div>
                    </div>
                </b-col>
                <b-col md="4">
                    <div class="card border-0 shadow-sm h-100">
                        <div class="card-header bg-light py-1 px-3">
                            <span class="font-weight-bold small text-uppercase">Parcelamento</span>
                        </div>
                        <div class="card-body p-0">
                            <b-table 
                                small 
                                hover 
                                responsive 
                                class="mb-0 modern-premium-table compact"
                                :items="modalCompraAnimais.parcelas" 
                                :fields="modalCompraAnimais.fieldsParcelas"
                                show-empty
                                empty-text="Nenhum parcelamento gerado"
                            >
                                <template #cell(DT_VENCIMENTO)="row">
                                    <b-form-input type="date" size="sm" v-model="row.item.DT_VENCIMENTO" :state="!!row.item.DT_VENCIMENTO" :disabled="modalCompraAnimais.abate.OP_COMPRADO !== null && modalCompraAnimais.abate.OP_COMPRADO !== '1'" class="py-0 h-auto"></b-form-input>
                                </template>
                            </b-table>
                        </div>
                        <div class="card-footer bg-light p-2">
                            <div class="d-flex align-items-center justify-content-between">
                                <div class="d-flex align-items-center gap-2">
                                    <label class="small mb-0 mr-2">Número de Parcelas:</label>
                                    <b-form-input type="number" size="sm" v-model="modalCompraAnimais.nrParcelas" :disabled="modalCompraAnimais.abate.OP_COMPRADO !== null && modalCompraAnimais.abate.OP_COMPRADO !== '1'" style="width: 70px" min="1" @input="gerarParcelasCompraAnimais()"></b-form-input>
                                </div>
                                <small class="text-muted">As parcelas serão geradas automaticamente</small>
                            </div>
                        </div>
                    </div>
                </b-col>
            </b-row>
        </div>
      </b-modal>
    </div>

    <ModalAlertaResultadoGrande
      ref="modalConfirmarResultadoGrande"
      :count="resultadoPendenteCount"
      @confirmar="confirmarCarregarResultadoGrande"
      @cancelar="cancelarCarregarResultadoGrande"
      @shown="onModalShown"
      @hidden="onModalHidden"
    />
  </div>
</template>

<script>
// https://github.com/simonbengtsson/jsPDF-AutoTable/blob/master/examples/webpack/main.js
import VueButtonSpinner from '../../../components/VueButtonSpinner.vue'
import ClientePesquisa from '../../pesquisa/ClientePesquisa.vue'
import CecInputData from '@/components/Cec/CecInputData.vue'
import TransportadoraDropDown from '@/views/componentes/dropdown/TransportadoraDropDown.vue'
import HistoricoDropDown from '@/views/componentes/dropdown/HistoricoCaixaDropdown.vue'
import CentroCustoDropDown from '@/views/componentes/dropdown/CentroCustoDropDown.vue'
import FuncionarioDropDown from '@/views/componentes/dropdown/FuncionarioDropdown.vue'
import SetFilter from '@/components/Cec/SetFilter.vue'
import moment from 'moment'
import VueAutonumeric from 'vue-autonumeric'
import Tools from '@/tools/tools.js'
import { createCecTableToolsMixin } from '@/mixins/cecTableTools'
import { mapGetters } from 'vuex';
import ModalAlertaResultadoGrande from '@/views/modal/ModalAlertaResultadoGrande.vue'
import { printHtmlReport, exportExcelXlsx , exportCsv } from '@/utils/RelatorioHTML'

export default {
  components: {
    ClientePesquisa,
    CecInputData,
    ModalAlertaResultadoGrande,
    VueButtonSpinner,
    VueAutonumeric,
    TransportadoraDropDown,
    HistoricoDropDown,
    CentroCustoDropDown,
    FuncionarioDropDown,
    SetFilter,
    moment
  },

  mixins: [createCecTableToolsMixin({
    rowsProp: 'lista',
    tblRef: 'tbl',
    useExternalPaging: true,
    filters: [
      { key: 'ID', type: 'number', label: 'ID' },
      { key: 'LOTE', type: 'string', label: 'Lote' },
      { key: 'NOME_FORNECEDOR', type: 'string', label: 'Fornecedor' },
      { key: 'STATUS', type: 'string', label: 'Status' },
      { key: 'TIPO_SERVICO_TRADUZIDO', type: 'string', label: 'Processo' },
      { key: 'OP_FECHADO_DIARIO', type: 'string', label: 'Miúdo' },
      { key: 'EXISTE_PLANO', type: 'string', label: 'PE' },
      { key: 'DT_LOTE', type: 'date', label: 'Data' },
      { key: 'BOI_PECAS', type: 'string', label: 'Tipos' },
      { key: 'ANIMAIS', type: 'number', label: 'Cabeças' },
      { key: 'QUANT', type: 'number', label: 'Peso KG' }
    ]
  })],

  data () {
    return {
      moment: moment,
      resultadoPendente: null,
      resultadoPendenteCount: 0,
      modalConfirmacaoAberto: false,
      modalBoletim: {
        data: moment().format('YYYY-MM-DD')
      },
      modalCompraAnimais: {
        busy: false,
        abate: {},
        animais: [],
        parcelas: [],
        nrParcelas: 1,
        pelaDataCompra: true,
        marchantNome: '',
        fornecedorNome: '',
        fazendaNome: '',
        transportadoraNome: '',
        opcoesCredor: [
          { value: '1', text: '1 - Marchant' },
          { value: '2', text: '2 - Fornecedor' },
          { value: '3', text: '3 - Fazenda' },
          { value: '4', text: '4 - Transportadora' }
        ],
        fieldsAnimais: [
          { key: 'PRODUTO_ID', label: 'Prod Id', sortable: true },
          { key: 'DESCRICAO', label: 'Produto', sortable: true },
          { key: 'NOME_CLASSIFICACAO', label: 'Classificação', sortable: true },
          { key: 'QUANT', label: 'Peso', sortable: true, tdClass: 'text-right', formatter: (v) => v ? v.toLocaleString('pt-BR', { minimumFractionDigits: 2 }) : '0,00' },
          { key: 'PECAS', label: 'Cabeças', sortable: true, tdClass: 'text-right' },
          { key: 'VL_ARROBA', label: 'Vl. Arroba @', sortable: true, tdClass: 'text-right' },
          { key: 'VL_TOTAL', label: 'Total', sortable: true, tdClass: 'text-right', formatter: (v) => v ? v.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) : 'R$ 0,00' }
        ],
        fieldsParcelas: [
          { key: 'PARCELA', label: 'Parcela' },
          { key: 'DT_VENCIMENTO', label: 'Vencimento' },
          { key: 'VL_PARCELA', label: 'Valor R$', tdClass: 'text-right', formatter: (v) => v ? v.toLocaleString('pt-BR', { minimumFractionDigits: 2 }) : '0,00' }
        ]
      },
      filtro: {
        avancado: false
      },
      cancelamento: {
        parametros: {
          overlayBaixando: false,
          permissao: false,
          processando: false,
          busy: false
        },
        dados: {
          titulo: null,
          id: null,
          nomeCliente: '',
          documento: '',
          parcela: '',
          motivo: '',
          dataVencimento: 0.00,
          gta: '',
          valorDocumento: 0.00,
          usuario: ''
        }
      },
      registro: {
        ID: null,
        CLIENTE_ID: null,
        FAZENDA_ID: null,
        OP_DEVEDOR: null,
        VL_SERVICO_CABECA: null,
        NR_CABECAS: null,
        VL_TOTAL_SERVICO: null,
        DT_VENCIMENTO_ARECEBER: null,
        HISTORICO_ARECEBER_ID: null,
        CENTRO_CUSTO_ARECEBER_ID: null,
        USUARIO_CADASTRO: null,
        campos: {
          VL_SERVICO_CABECA : false,
          NR_CABECAS: false,
          VL_TOTAL_SERVICO: false,
          DT_VENCIMENTO_ARECEBER : false,
          HISTORICO_ARECEBER_ID : false,
          CENTRO_CUSTO_ARECEBER_ID : false
        }
      },
      tipoGerarTitulo: [
        {value: '0', text: '0 - Ninguém (Sem taxa de Serviço)'},
        {value: '1', text: '1 - Marchant (Cobrar Serviço)'},
        {value: '2', text: '2 - Fornecedor (Cobrar Serviço)'},
        {value: '3', text: '3 - Fazenda (Cobrar Serviço)'},
      ],
      dadosModalInfo: {
        id: null,
        documento: null,
        dataVenda : null,
        nomeCliente: null,
        nomeVendedor: null,
        usuarioAlteracao: null,
        dataAlteracao: null,
        motivoAlteracao: null,
        usuarioCancelamento: null,
        dataCancelamento: null,
        motivoCancelamento: null,
        total: 0.00

      },
      tabelaItens: {
        fields: [
          {
            key: "CODIGO_NOME_PRODUTO",
            label: 'Produto'
          },
          {
            key: "QUANT",
            label: 'Quantidade',
            formatter: (value, key, item) => 
                value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3})
          },
          {
            key: "PECAS",
            label: 'Peças'
          },
          {
            key: "TX_UNIDADE_COMERCIAL",
            label: 'UND'
          },
          {
            key: 'VL_UNT', 
            class:'text-right', 
            label: 'Valor (R$)', 
            formatter: (value, key, item) => 
                value.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})
          },
          {
            key: 'VL_DESCONTO', 
            class:'text-right', 
            label: 'Desconto (R$)', 
            formatter: (value, key, item) => 
                value.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})
          },
          {
            key: 'VL_TOTAL_BRUTO', 
            class:'text-right', 
            label: 'Total (R$)', 
            formatter: (value, key, item) => 
                value.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})
          }
        ],
        items: []
      },
      optionsTipoProcesso: [
        { value: '0', text: '0 -Ambos' },
        { value: '1', text: '1 - Próprio' },
        { value: '2', text: '2 - Serviço' }
      ],
      status: '',
      isBusy: false,
      fields: [
        {
          key: "ID",
          label: 'Id',
          sortable: true,
          class:'text-right font-weight-bold my-left-border my-left-right my-left-bottom align-middle',
        },
        {
          key: "LOTE",
          label: 'Lote',
          class:'text-right font-weight-bold my-left-border my-left-right my-left-bottom align-middle',
          sortable: true 
        },
        {
          key: "NOME_FORNECEDOR",
          label: 'Fornecedor', 
          thStyle: { width: "20%" },
          class: 'my-left-border my-left-right my-left-bottom', 
          sortable: true 
        },
        {
          key: "STATUS",
          label: 'Status', 
          sortable: true,
          class: 'my-left-border my-left-right my-left-bottom align-middle', 
          thStyle: { width: "5%" }, 
        },
        {
          key: "OP_COMPRADO",
          label: 'Comprado',
          class: 'my-left-border my-left-right my-left-bottom align-middle',
          thStyle: { width: "7%" },
          sortable: true
        },
        {
          key: "TIPO_SERVICO_TRADUZIDO",
          label: 'Processo',
          class: 'my-left-border my-left-right my-left-bottom align-middle', 
          thStyle: { width: "7%" },
          sortable: true 
        },
        {
          key: "OP_FECHADO_DIARIO",
          label: 'Miúdo',
          class: 'my-left-border my-left-right my-left-bottom align-middle', 
          sortable: true 
        },
        {
          key: "EXISTE_PLANO",
          label: 'PE',
          class: 'my-left-border my-left-right my-left-bottom align-middle', 
          sortable: true 
        },
        {
          key: "DT_LOTE",
          label: 'Data', 
          sortable: true,
          
          class:'text-right my-left-border my-left-right my-left-bottom align-middle',
          formatter: (value, key, item) => 
            value = value ? moment(String(value)).format('DD/MM/YYYY') : null
        },
        {
          key: "BOI_PECAS",
          label: 'Tipos ', 
          class:'text-right my-left-border my-left-right my-left-bottom align-middle',
          thStyle: { width: "10%" },
          sortable: true 
        },
        {
          key: "ANIMAIS",
          label: 'Cabeças', 
          class:'text-right my-left-border my-left-right my-left-bottom align-middle',
          thStyle: { width: "7%" },
          sortable: true 
        },
        {
          key: 'QUANT', 
          class:'text-right', 
          label: 'Peso KG', 
          class:'text-right font-weight-bold my-left-border my-left-right my-left-bottom align-middle' ,
          sortable: true,
          formatter: (value, key, item) => 
            value ? value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3}) : null
        },
        {
          key: "actions" ,
          label: 'Ações',
          
           class:'text-right align-middle',
           thStyle: { width: "12%" }
        }
      ],
      perPage: 50,
      sortBy: null,
      sortDesc: false,
      filter: null,
      modalDetails: { index: '', data: '' },
      modalUpload: {
        file: null,
        nomeCliente: null,
        loteId: null,
        motivoCancelamento: null,
        lote: null,
        imagem: null
      },
      planoExpedicao: {
        items: [],
        fields: [
          {
            key: 'MARCA',
            label: 'Marca',
            thStyle: { width: '8%' },
            thClass: 'text-center',
            class: 'text-center'
          },
          {
            key: 'NOME_PRODUTO_CORTADO',
            label: 'Cortado'
          },
          {
            key: 'NOME_PRODUTO_PRINCIPAL',
            label: 'Produto'
          },
          {
            key: 'PECAS',
            label: 'Peças',
            thClass: 'text-right',
            class: 'text-right'
          },
          {
            key: 'OBRIGATORIO_TRADUZIDO',
            label: 'Obrigatório',
            thClass: 'text-center',
            class: 'text-center'
          }
        ],
        observacao: '',
        busy: false,
        abateId: null,
        existePedido: null,
        mensagem: null
      },
      columns: [
        {title: 'ID', dataKey: 'id'},
        {title: 'Name', dataKey: 'name'},
        {title: 'Country', dataKey: 'country'}
      ],
      statusOptions: [
        {text: 'CANCELADA', value: '0'},
        {text: 'LANCAMENTOS PRINCIPAIS', value: '1'},
        {text: 'PLANEJAMENTO CONCLUIDO', value: '2'},
        {text: 'PRONTO PARA COLETA', value: '3'},
        {text: 'COLETA INICIADA', value: '4'},
        {text: 'COLETA ENCERRADA', value: '5'},
        {text: 'FECHADO', value: '6'},
        {text: 'PAUSA', value: '7'}
      ],
      rows: [
        {'id': 1, 'name': 'Shaw', 'country': 'Tanzania'},
        {'id': 2, 'name': 'Nelson', 'country': 'Kazakhstan'},
        {'id': 3, 'name': 'Garcia', 'country': 'Madagascar'}
      ],
      detalhes: {
        loading: false,
        animais: {
          items: [],
          fields: [
            { key: 'NOME_PRODUTO', label: 'Animal / Produto' },
            { key: 'NOME_CENTRO_ESTOQUE', label: 'Estoque' },
            { key: 'PECAS', label: 'Cabeças', class: 'text-right' },
            { 
              key: 'QUANT', 
              label: 'Peso KG', 
              class: 'text-right',
              formatter: value => value ? value.toLocaleString('pt-BR', { minimumFractionDigits: 3 }) : '0,000'
            }
          ]
        },
        resumo: {
          items: [],
          fields: [
            { key: 'DESCRICAO', label: 'Animal' },
            { key: 'BANDAS', label: 'Bandas', class: 'text-right' },
            { key: 'ANIMAIS', label: 'Cabeças', class: 'text-right' },
            { 
              key: 'QUANT', 
              label: 'Peso KG', 
              class: 'text-right',
              formatter: value => value ? value.toLocaleString('pt-BR', { minimumFractionDigits: 3 }) : '0,000'
            },
            { 
              key: 'MEDIA', 
              label: 'Média KG', 
              class: 'text-right',
              formatter: value => value ? value.toLocaleString('pt-BR', { minimumFractionDigits: 2 }) : '0,00'
            }
          ]
        }
      }
    }
  },
  computed: {
    ...mapGetters('tema',{isDark: 'IS_DARK'}),
    currentPage: {
      get () {
        return this.$store.getters['ordemAbate/PAGINA_ATUAL']
      }, 
      set (value) {
        this.$store.commit("ordemAbate/SET_PAGINA_ATUAL", value);
      }
    },
    dt1: {
      get () {
        return this.$store.getters['ordemAbate/DT1']
      }, 
      set (value) {
        this.$store.commit("ordemAbate/SET_DT1", value);
      }
    },
    dt2: {
      get () {
        return this.$store.getters['ordemAbate/DT2']
      }, 
      set (value) {
        this.$store.commit("ordemAbate/SET_DT2", value);
      }
    },
    id: {
      get () {
        return this.$store.getters['ordemAbate/ID']
      }, 
      set (value) {
        this.$store.commit("ordemAbate/SET_ID", value);
      }
    },
    gta: {
      get () {
        return this.$store.getters['ordemAbate/GTA']
      }, 
      set (value) {
        this.$store.commit("ordemAbate/SET_GTA", value);
      }
    },
    confirmPlanoExpedicaoDisabled() {
      if (this.planoExpedicao.busy || this.planoExpedicao.existePedido === true) return true
      return this.faltamItensObrigatorios
    },
    faltamItensObrigatorios() {
      return this.planoExpedicao.items.some(item => item.OP_OBRIGATORIO === '1' && !item.selecionado)
    },
    clienteId: {
      get () {
        return this.$store.getters['ordemAbate/CLIENTE_ID']
      }, 
      set (value) {
        this.$store.commit("ordemAbate/SET_CLIENTE_ID", value)
      }
    },
    fazendaId: {
      get () {
        return this.$store.getters['ordemAbate/FAZENDA_ID']
      }, 
      set (value) {
        this.$store.commit("ordemAbate/SET_FAZENDA_ID", value)
      }
    },
    marchanteId: {
      get () {
        return this.$store.getters['ordemAbate/MARCHANTE_ID']
      }, 
      set (value) {
        this.$store.commit("ordemAbate/SET_MARCHANTE_ID", value)
      }
    },
    tipoProcesso: {
      get () {
        return this.$store.getters['ordemAbate/TIPO_PROCESSO']
      }, 
      set (value) {
        this.$store.commit("ordemAbate/SET_TIPO_PROCESSO", value)
      }
    },
    tipoStatus: {
      get () {
        return this.$store.getters['ordemAbate/TIPO_STATUS']
      }, 
      set (value) {
        this.$store.commit("ordemAbate/SET_TIPO_STATUS", value)
      }
    },
    lista: {
      get () {
        return this.$store.getters['ordemAbate/LISTA']
      }, 
      set (value) {
        this.$store.commit("ordemAbate/SET_LISTA", value)
      }
    },
    totalCabecas() {
      return this.lista.reduce((acc, item) => acc + (parseFloat(item.ANIMAIS) || 0), 0)
    },
    totalPeso() {
      return this.lista.reduce((acc, item) => acc + (parseFloat(item.QUANT) || 0), 0)
    }
  },
  methods: {
    showDetalhes(item) {
      // Fecha os detalhes de todas as outras linhas
      
      this.lista.forEach((row) => {
        this.$set(row, '_showDetails', false);
      });

      // Abre os detalhes da linha clicada
      this.$set(item, '_showDetails', !item._showDetails);
    },
    cancelar() {
      if (this.modalUpload.motivoCancelamento == null) {
        this.toastCount++
        this.$root.$bvToast.toast('Informe o motivo!', {
          title: 'Aviso',
          autoHideDelay: 2000,
          variant: 'warning',
          appendToast: true
        })
        return
      }
      this.$store.commit('controle/setAguardando', true)
      let pacote = {
        abateId: this.modalUpload.loteId,
        motivo: this.modalUpload.motivoCancelamento,
        login: window.localStorage.getItem('login')

      }
      this.$http.post( `/api/protected/producao/deleteWeb/`, pacote)
      .then(() => {
        for (let i = 0; i < this.lista.length; i++) {
          if (this.lista[i].ID == this.modalUpload.loteId) {
            this.lista[i].OP_STATUS = '0'
            this.lista[i].STATUS = 'CANCELADA'
          }
        }
        this.$store.commit('controle/setAguardando', false)
        this.$refs['modal-cancelamento'].hide()
        return
      })
      .catch(erro => {
        this.$store.commit('controle/setAguardando', false)
        this.$refs['modal-cancelamento'].hide()
          if (erro.response.status == 400) {
            this.toastCount++
            this.$root.$bvToast.toast(`Não foi possivel Cancelar: ${erro.response.data}`, {
              title: 'Falha',
              autoHideDelay: 4000,
              variant: 'warning',
              appendToast: true
            })
          }
      })

      
    },
    abrirModalRemoveArquivo(item) {
      this.$store.commit('controle/setAguardando', true)
      this.modalUpload.file = null
      this.modalUpload.nomeCliente = item.NOME_FORNECEDOR
      this.modalUpload.loteId = item.ID
      this.modalUpload.lote = item.LOTE


      this.$refs['modal-upload-remove'].show()
      this.$store.commit('controle/setAguardando', false)
    },
    getImagem(id) {
      return new Promise((resolve, reject) => {
        this.$http.get( `/api/protected/producao/getArquivo/${id}`)
        .then((result) => {
          this.modalUpload.imagem = result.data
          resolve(true)
        })
        .catch(erro => {
          this.$refs['modal-cancelamento'].hide()
            if (erro.response && erro.response.status == 400) {
              this.toastCount++
              this.$root.$bvToast.toast(`Não foi possivel Carregar a Imagem: ${erro.response.data}`, {
                title: 'Falha',
                autoHideDelay: 4000,
                variant: 'warning',
                appendToast: true
              })
            } else {
              this.toastCount++
              this.$root.$bvToast.toast(`Não foi possivel carregar a Imagem: ${erro}`, {
                title: 'Falha',
                autoHideDelay: 4000,
                variant: 'warning',
                appendToast: true
              })
            }
          reject(false)
        })
      })
    },
    async abrirModalUpload(item) {
      this.$store.commit('controle/setAguardando', true)
      this.modalUpload.file = null
      this.modalUpload.nomeCliente = item.NOME_FORNECEDOR
      this.modalUpload.loteId = item.ID
      this.modalUpload.lote = item.LOTE
      this.modalUpload.itemDaTabela = item
      this.modalUpload.imagem = null
      
      if( await this.getImagem(item.ID) == false) {
        return
      }
      
      this.$store.commit('controle/setAguardando', true)
      this.$refs['modal-upload'].show()
      
      
    },
    abrirModalInfo(item) {

      this.$store.commit('controle/setAguardando', true)
      this.tabelaItens.items = null
      this.dadosModalInfo.id = null
      this.dadosModalInfo.documento = null
      this.dadosModalInfo.dataVenda = null
      this.dadosModalInfo.nomeCliente = null
      this.dadosModalInfo.nomeVendedor = null
      this.dadosModalInfo.total = null
      
      this.dadosModalInfo.usuarioAlteracao = null
      this.dadosModalInfo.dataAlteracao = null
      this.dadosModalInfo.motivoAlteracao = null
      this.dadosModalInfo.usuarioCancelamento = null
      this.dadosModalInfo.dataCancelamento = null
      this.dadosModalInfo.motivoCancelamento = null
      
      this.$http.get('/api/protected/venda/item/getListagemByVenda/'+item.ID)
      .then((response) => {
        this.tabelaItens.items = response.data
        this.dadosModalInfo.id = item.ID
        this.dadosModalInfo.documento = item.N_VENDA
        this.dadosModalInfo.dataVenda = item.DT_SAIDA ? moment(String(item.DT_SAIDA)).format('DD/MM/YYYY') : ''
        this.dadosModalInfo.nomeCliente = item.NOME_CLIENTE
        this.dadosModalInfo.nomeVendedor = item.NOME_VENDEDOR
        this.dadosModalInfo.total = item.VL_TOTAL_NFE ? item.VL_TOTAL_NFE.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) : 0.00
        
        this.dadosModalInfo.usuarioAlteracao = item.TX_USUARIO_ALTERACAO
        this.dadosModalInfo.dataAlteracao = item.DT_ALTERACAO ? moment(String(item.DT_ALTERACAO)).format('DD/MM/YYYY') : ''
        this.dadosModalInfo.motivoAlteracao = item.OBS3
        this.dadosModalInfo.usuarioCancelamento = item.TX_USUARIO_CANCELAMENTO
        this.dadosModalInfo.dataCancelamento = item.DT_CANC ? moment(String(item.DT_CANC)).format('DD/MM/YYYY') : ''
        this.dadosModalInfo.motivoCancelamento = item.MOT_CANC

        this.$refs['modal-info'].show()
        this.$store.commit('controle/setAguardando', false)
      })
    },
    focusModalRemoveArquivo() {
    },
    focusModalUpload() {
      if (this.modalUpload.imagem == null) {
        this.$refs.edUpload.$refs.input.focus()
      }
    },
    async onRemoverArquivo() {
      this.$store.commit('controle/setAguardando', true)
      
      this.$http.post(`api/protected/abate/removerArquivo/${this.modalUpload.loteId}`)
      .then(() => {
        this.$store.commit('controle/setAguardando', false)
        this.modalUpload.imagem = null
        
        this.$store.commit('controle/setAguardando', false)
        this.$root.$bvToast.toast(`Aviso!!! Arquivo Removido com sucesso `, {
          title: 'Aviso',
          autoHideDelay: 3000,
          variant: 'success',
          appendToast: true
        })
      })
      .catch((err) => {
        this.$store.commit('controle/setAguardando', false)
        this.$root.$bvToast.toast(`Aviso!!!  Falha na Remoção ${err}`, {
          title: 'Aviso',
          autoHideDelay: 3000,
          variant: 'warning',
          appendToast: true
        })
      })
    },
    async onFechamento() {
      if (this.registro.OP_DEVEDOR != '0') {
        let avisos = (!this.registro.HISTORICO_ARECEBER_ID) 
          ||  (parseFloat(this.registro.VL_TOTAL_SERVICO) <= 0) 
          || (parseFloat(this.registro.VL_SERVICO_CABECA) <= 0) 
          || (!this.registro.CENTRO_CUSTO_ARECEBER_ID) 
          || (!this.registro.DT_VENCIMENTO_ARECEBER) 
        
        if (avisos == true)  {
          this.$root.$bvToast.toast(`Atenção!!! Informe todos os campos obrigatórios`, {
            title: 'Atenção',
            autoHideDelay: 3000,
            variant: 'warning',
            appendToast: true
          })
          return
        }
      }
      
      this.$http.post(`api/protected/producao/fecharWeb/`, this.registro)
      .then(() => {
        this.$store.commit('controle/setAguardando', false)
        for (let i = 0; i < this.lista.length; i++) {
          if (this.lista[i].ID == this.registro.ID) {
            this.lista[i].OP_STATUS = '6'
          }
        }
        this.$refs['modal-fechamento'].hide()

        this.$store.commit('controle/setAguardando', false)
        this.$root.$bvToast.toast(`Aviso!!! Fechamento Executado com Sucesso! `, {
          title: 'Aviso',
          autoHideDelay: 3000,
          variant: 'success',
          appendToast: true
        })
        return
      })
      .catch((err) => {
        this.$store.commit('controle/setAguardando', false)
        this.$root.$bvToast.toast(`Aviso!!!  Falha ao executar o fechamento ${err}`, {
          title: 'Aviso',
          autoHideDelay: 3000,
          variant: 'warning',
          appendToast: true
        })
      })

      this.$store.commit('controle/setAguardando', false)

    },
    async onUpload() {
      if (this.modalUpload.file == null ) {
        this.$root.$bvToast.toast(`Aviso!!!  Informe todos os campos obrigatórios`, {
          title: 'Aviso',
          autoHideDelay: 3000,
          variant: 'warning',
          appendToast: true
        })
        return
      }
      this.$store.commit('controle/setAguardando', true)
      let formData = new FormData()
      formData.append('files', this.modalUpload.file, this.modalUpload.file.name)

      this.$http.post(`api/protected/abate/upload/${this.modalUpload.loteId}/${window.localStorage.getItem('login')}`, formData)
      .then(result => {
        this.$store.commit('controle/setAguardando', false)
        

        this.$store.commit('controle/setAguardando', false)
        this.$root.$bvToast.toast(`Aviso!!! Upload com sucesso `, {
          title: 'Aviso',
          autoHideDelay: 3000,
          variant: 'success',
          appendToast: true
        })
        this.getImagem(this.modalUpload.loteId)
        return
      })
      .catch((err) => {
        this.$store.commit('controle/setAguardando', false)
        this.$root.$bvToast.toast(`Aviso!!!  Falha no Upload ${err}`, {
          title: 'Aviso',
          autoHideDelay: 3000,
          variant: 'warning',
          appendToast: true
        })
      })
    },
    abrirModalCancelamento(item) {
      this.$store.commit('controle/setAguardando', true)
      this.modalUpload.file = null
      this.modalUpload.nomeCliente = item.NOME_FORNECEDOR
      this.modalUpload.loteId = item.ID
      this.modalUpload.lote = item.LOTE
      this.modalUpload.motivoCancelamento = null


      this.$refs['modal-cancelamento'].show()
      this.$store.commit('controle/setAguardando', false)
    },
    async getTotalAnimais(id) {
      this.registro.NR_CABECAS =  null
      this.$http.get(`/api/protected/abate/getTotalAnimaisByAbateId/${id}`)
      .then((data) => {
        this.registro.NR_CABECAS = data.data
        return true
      }).catch((error) => {
        return false
      })
    },
    async abrirModalFechamento(item) {
      this.$store.commit("ordemAbate/SET_REGISTRO_SELECIONADO_ID", item.ID)
      this.$store.commit('controle/setAguardando', true)
      let reg = await this.getRegistroById(item.ID)
      if (reg == null) {
        
        this.$store.commit('controle/setAguardando', false)
        this.$bvToast.toast(`Não foi possível encontrar a Ordem de Abate!!`, {
          title: 'Erro',
          autoHideDelay: 5000,
          variant: 'warning',
          appendToast: true
        })
        this.$store.commit('controle/setAguardando', false)
        return
      }

      // Verifica se é processo próprio ou serviço
      const tipoProcesso = reg.data.OP_TIPO_SERVICO
      
      if (tipoProcesso === '1') {
        // Processo Próprio - abre modal de confirmação simples
        this.registro.ID = reg.data.ID
        this.registro.LOTE = reg.data.LOTE
        this.registro.CLIENTE_ID = reg.data.CLIENTE_ID
        this.registro.NOME_CLIENTE = item.NOME_FORNECEDOR
        this.registro.FAZENDA_ID = reg.data.FAZENDA_ID
        this.registro.NOME_FAZENDA = item.NOME_FAZENDA
        this.registro.MARCHANT_ID = reg.data.MARCHANT_ID
        this.$refs['modal-fechamento-proprio'].show()
        this.$store.commit('controle/setAguardando', false)
        return
      }

      // Processo Serviço - continua com modal normal
      if (await this.getTotalAnimais(item.ID) == false) {
        this.$store.commit('controle/setAguardando', false)
        this.$bvToast.toast(`Não foi possível encontrar o Total de Animais!!`, {
          title: 'Erro',
          autoHideDelay: 5000,
          variant: 'warning',
          appendToast: true
        })
        this.$store.commit('controle/setAguardando', false)
        return
      }

      
      
      this.registro.ID = reg.data.ID
      this.registro.CLIENTE_ID = reg.data.CLIENTE_ID
      this.registro.FAZENDA_ID = reg.data.FAZENDA_ID
      this.registro.OP_DEVEDOR = reg.data.OP_DEVEDOR ? reg.data.OP_DEVEDOR : '0'
      this.registro.VL_SERVICO_CABECA = reg.data.VL_SERVICO_CABECA ? reg.data.VL_SERVICO_CABECA : 0.00
      // this.registro.NR_CABECAS = reg.data[0].NR_CABECAS
      this.registro.MARCHANT_ID = reg.data.MARCHANT_ID
      this.registro.VL_TOTAL_SERVICO = reg.data.VL_TOTAL_SERVICO ? reg.data.VL_TOTAL_SERVICO : 0.00
      this.registro.DT_VENCIMENTO_ARECEBER = reg.data.DT_VENCIMENTO_ARECEBER ? moment(new Date(reg.data.DT_VENCIMENTO_ARECEBER)).format('YYYY-MM-DD') : null
      this.registro.HISTORICO_ARECEBER_ID = reg.data.HISTORICO_ARECEBER_ID
      this.registro.CENTRO_CUSTO_ARECEBER_ID = reg.data.CENTRO_CUSTO_ARECEBER_ID
      this.registro.USUARIO_CADASTRO = window.localStorage.getItem('login')

      this.$refs['modal-fechamento'].show()
      this.$store.commit('controle/setAguardando', false)
    },
    async getRegistroById(id) {
      return new Promise(resolve => {
        this.$http.get(`/api/protected/producao/getById/${id}`)
        .then((result) =>{
          resolve(result)
        })
        .catch(erro => {
          this.$store.commit('controle/setAguardando', false)
          if (erro.response.status == 400) {
            this.toastCount++
            this.$root.$bvToast.toast(`Atenção: ${erro.response.data}`, {
              title: 'Atenção',
              autoHideDelay: 3000,
              variant: 'warning',
              appendToast: true
            })
          }
          resolve(false)
        })
      })
        
    },
    onFecharModalUpload() {
      this.$store.commit('controle/setAguardando', false)
      this.$refs['modal-upload'].hide()
    },
    focusModalCancelamento() {
      this.$refs.edMotivoCancelamento.focus()
    },
    focusModalFechamento() {
      this.$refs.comboGerarTitulo.focus()
    },
    async onConfirmarFechamentoProprio() {
      this.$store.commit('controle/setAguardando', true)
      
      const params = {
        abateId: this.registro.ID,
        usuario: window.localStorage.getItem('login')
      }
      
      this.$http.post('/api/protected/abate/fecharProprio', null, { params })
        .then(() => {
          this.$bvToast.toast('Fechamento da Ordem de Abate realizado com sucesso!', {
            title: 'Sucesso',
            autoHideDelay: 3000,
            variant: 'success',
            appendToast: true
          })
          this.$refs['modal-fechamento-proprio'].hide()
          this.pesquisar()
        })
        .catch((erro) => {
          this.$bvToast.toast(erro.response?.data || 'Erro ao fechar a ordem de abate', {
            title: 'Erro',
            autoHideDelay: 5000,
            variant: 'danger',
            appendToast: true
          })
        })
        .finally(() => {
          this.$store.commit('controle/setAguardando', false)
        })
    },
    limpar() {
      this.$store.commit("ordemAbate/SET_LIMPAR", null)
    },
    rowClassSelecionado(item, type) {
      if (item && type === 'row') {
        return item.ID === this.$store.getters['ordemAbate/REGISTRO_SELECIONADO_ID'] ? 'table-success' : ''
      }
    },
    colorirTipoServico(valor) {
      if (valor == '1') return 'success' //Proprio
      else if (valor == '2') return 'orange' // Servico
      else return 'success'
    },
    colorirFechadoDiario(valor) {
      if (valor == '0') return 'text-yellow' //Nao
      else if (valor == '1') return 'text-success' // Sim
      else if (valor == '1') return 'text-success' // Sim
      else return 'text-yellow'//nao
    },
    colorirExistePlano(valor) {
      if (valor == '0') return 'text-yellow' //Sim
      else if (valor == '1') return 'text-success' // Nao
      else return 'text-dark'
    },
    colorirBotaoUpload(item) {
      if (item.EXISTE_ARQUIVO == 0) return 'outline-warning' // N EXISTE
      else if (item.EXISTE_ARQUIVO > 1) return 'green' //EXISTE
      else return ''
    },
    colorirStatus(valor) {
      if (valor == '0') return 'danger' // cancelada
      else if (valor == '1') return 'yellow' //lancamentos principais
      else if (valor == '2') return 'teal' // Planejamento Iniciado
      else if (valor == '3') return 'blue' // Pronto para coleta
      else if (valor == '4') return 'purple' // Colente Iniciada
      else if (valor == '5') return 'orange' // coleta encerrada
      else if (valor == '6') return 'green' // fechado
      else if (valor == '7') return 'gray-200' // pausa
      else return 'gray-dark'
    },
    traduzirStatus(item) {
      if (item == null) return ''
      
      switch (item) {
        case  '0' : return 'CANCELADA'
        case  '1' : return 'LANCAMENTO PRINCIPAIS' 
        case  '2' : return 'PLANEJAMENTO CONCLUIDO' 
        case  '3' : return 'PRONTO PARA COLETA' 
        case  '4' : return 'COLETA INICIADA' 
        case  '5' : return 'COLETA ENCERRADA'     
        case  '6' : return 'FECHADO' 
        case  '7' : return 'PAUSA' 
        default: 
          break;
      }
    },
    colorirOpComprado(valor) {
      if (valor === null || valor === undefined) return 'secondary'
      else if (valor === '1') return 'warning'
      else if (valor === '2') return 'info'
      else if (valor === '3') return 'primary'
      else if (valor === '4') return 'success'
      else return 'dark'
    },
    traduzirOpComprado(valor) {
      if (valor === null || valor === undefined) return 'Aberto'
      
      switch (String(valor)) {
        case '1': return 'Precificado'
        case '2': return 'Nota Fiscal'
        case '3': return 'Financeiro Gerado'
        case '4': return 'NFE e Financeiro'
        default: return '(Null)'
      }
    },
    details (item) {
      alert(JSON.stringify(item.item.ID))
    },
    async onSetarLiberarColeta(item) {
      const imprimir = await this.$bvModal.msgBoxConfirm('Liberar a Ordem de Abate para a Coleta no Terminal?.', {
        title: 'Terminal de Coleta',
        size: 'sm',
        buttonSize: 'xl',
        okVariant: 'success',
        okTitle: 'SIM',
        cancelTitle: 'NÃO',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true,
        noCloseOnEsc: true, 
        noCloseOnBackdrop: true
      })
      
      if (imprimir == false) {
        return
      }
      this.$store.commit('controle/setAguardando', true)
      this.$http.post(`/api/protected/producao/setarLiberarColeta/${item.ID}`)
      .then(() => {
        this.$store.commit('controle/setAguardando', false)
        for (let i = 0; i < this.lista.length; i++) {
          if (this.lista[i].ID == item.ID) {
            this.lista[i].OP_STATUS = '3'
          }
        }
        this.toastCount++
          this.$root.$bvToast.toast(`Ordem de Abate liberada para Coleta!!!`, {
            title: 'Aviso',
            autoHideDelay: 3000,
            variant: 'success',
            appendToast: true
          })
      })
      .catch(erro => {
          this.$store.commit('controle/setAguardando', false)
          if (erro.response.status == 400) {
            this.toastCount++
            this.$root.$bvToast.toast(`Ocorreu uma falha ao executar a ação: ${erro.response.data}`, {
              title: 'Atenção',
              autoHideDelay: 3000,
              variant: 'warning',
              appendToast: true
            })
          }
        })
    },
    onEdit (item) {
      if (['0','6'].includes(item.OP_STATUS)) {
        Tools.exibirMensagem(this.$store, 'Atenção', 'warning', 'A edição não é permitida para ordens com este status.')
        return
      }
      this.$store.commit("ordemAbate/SET_REGISTRO_SELECIONADO_ID", item.ID)
      this.$store.commit('controle/setAguardando', true)
      this.$router.push(`/producao/ordemabate/edit/${item.ID}`)
    },
    abrirModalBoletim() {
      this.modalBoletim.data = moment().format('YYYY-MM-DD')
      this.$refs['modal-boletim'].show()
    },
    onVisualizarBoletim() {
      this.$root.$bvToast.toast('Recurso em desenvolvimento. O PDF será gerado em breve.', {
        title: 'Aviso',
        variant: 'info',
        autoHideDelay: 3000
      })
    },
    async abrirModalCompraAnimais(item) {
      this.$store.commit('controle/setAguardando', true)
      try {
        const response = await this.$http.get(`/api/protected/producao/getById/${item.ID}`)
        // A API retorna um objeto diretamente
        const abate = response.data || {}
        
        // Inicializa campos numéricos para evitar problemas em cálculos
        abate.PERCENTUAL_FUNRURAL = abate.PERCENTUAL_FUNRURAL || 0
        abate.VL_FUNRURAL = abate.VL_FUNRURAL || 0
        abate.VL_TOTAL_BRUTO = abate.VL_TOTAL_BRUTO || 0
        abate.VL_TOTAL_COMPRA = abate.VL_TOTAL_COMPRA || 0
        
        // Inicializa outros campos para garantir reatividade
        if (abate.OP_CREDOR === undefined) abate.OP_CREDOR = ''
        if (abate.TRANSPORTADORA_ID === undefined) abate.TRANSPORTADORA_ID = null
        if (abate.HISTORICO_APAGAR_ID === undefined) abate.HISTORICO_APAGAR_ID = null
        if (abate.CENTRO_CUSTO_APAGAR_ID === undefined) abate.CENTRO_CUSTO_APAGAR_ID = null
        if (abate.COMPRADOR_ID === undefined) abate.COMPRADOR_ID = null
        
        // Converte OP_COMPRADO para string se não for null
        if (abate.OP_COMPRADO !== null && abate.OP_COMPRADO !== undefined) {
          abate.OP_COMPRADO = String(abate.OP_COMPRADO)
        }
        
        // Usar $set para garantir reatividade do Vue
        this.$set(this.modalCompraAnimais, 'abate', abate)
        this.$set(this.modalCompraAnimais, 'nrParcelas', 1)
        this.$set(this.modalCompraAnimais, 'pelaDataCompra', true)
        
        await this.carregarDadosCompraAnimais(item.ID)
        await this.traduzirNomesCompraAnimais()
        this.gerarParcelasCompraAnimais()
        
        this.$refs['modal-compra-animais'].show()
      } catch (error) {
        console.error(error)
        this.$root.$bvToast.toast('Erro ao carregar dados da compra', { variant: 'danger' })
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    async carregarDadosCompraAnimais(abateId) {
      try {
        const response = await this.$http.get(`/api/protected/producao/getAnimaisPrecificados/${abateId}`)
        this.modalCompraAnimais.animais = Array.isArray(response.data) ? response.data : []
        this.calcularTotaisCompraAnimais()
      } catch (error) {
        console.error(error)
      }
    },
    async traduzirNomesCompraAnimais() {
      const fetchNome = async (id) => {
        if (!id) return ''
        try {
          const res = await this.$http.get(`/api/protected/cliente/getById/${id}`)
          const cliente = (res.data && Array.isArray(res.data)) ? res.data[0] : res.data
          return cliente ? (cliente.NOME || cliente.NOME_CLIENTE || '') : ''
        } catch (e) { return '' }
      }
      
      this.$set(this.modalCompraAnimais, 'marchantNome', await fetchNome(this.modalCompraAnimais.abate.MARCHANT_ID))
      this.$set(this.modalCompraAnimais, 'fornecedorNome', await fetchNome(this.modalCompraAnimais.abate.CLIENTE_ID))
      this.$set(this.modalCompraAnimais, 'fazendaNome', await fetchNome(this.modalCompraAnimais.abate.FAZENDA_ID))
      this.$set(this.modalCompraAnimais, 'transportadoraNome', await fetchNome(this.modalCompraAnimais.abate.TRANSPORTADORA_ID))
    },
    calcularTotaisCompraAnimais() {
      let auxTotal = 0
      this.modalCompraAnimais.animais.forEach(animal => {
        const totalItem = Number(((animal.QUANT / 15) * animal.VL_ARROBA).toFixed(2))
        animal.VL_TOTAL = totalItem
        auxTotal += totalItem
      })
      
      this.modalCompraAnimais.abate.VL_TOTAL_COMPRA = Number(auxTotal.toFixed(2))
      this.modalCompraAnimais.abate.VL_TOTAL_BRUTO = this.modalCompraAnimais.abate.VL_TOTAL_COMPRA
      
      if (this.modalCompraAnimais.abate.PERCENTUAL_FUNRURAL > 0) {
        this.modalCompraAnimais.abate.VL_FUNRURAL = Number((this.modalCompraAnimais.abate.VL_TOTAL_COMPRA * (this.modalCompraAnimais.abate.PERCENTUAL_FUNRURAL / 100)).toFixed(2))
        this.modalCompraAnimais.abate.VL_TOTAL_COMPRA = Number((this.modalCompraAnimais.abate.VL_TOTAL_COMPRA - this.modalCompraAnimais.abate.VL_FUNRURAL).toFixed(2))
      } else {
        this.modalCompraAnimais.abate.VL_FUNRURAL = 0
      }
      
      this.gerarParcelasCompraAnimais()
    },
    gerarParcelasCompraAnimais() {
      const parcelas = []
      const total = this.modalCompraAnimais.abate.VL_TOTAL_COMPRA || 0
      const nr = parseInt(this.modalCompraAnimais.nrParcelas) || 1
      const valorParcela = Number((total / nr).toFixed(2))
      
      let dataBase = this.modalCompraAnimais.pelaDataCompra 
        ? moment(this.modalCompraAnimais.abate.DT_LOTE) 
        : moment(this.modalCompraAnimais.abate.DT_VENCIMENTO_APAGAR || this.modalCompraAnimais.abate.DT_LOTE)

      for (let i = 1; i <= nr; i++) {
        parcelas.push({
          ID: this.modalCompraAnimais.abate.ID,
          ABATE_ID: this.modalCompraAnimais.abate.ID,
          PARCELA: i,
          DT_VENCIMENTO: dataBase.clone().add(i - 1, 'months').format('YYYY-MM-DD'),
          VL_PARCELA: i === nr ? Number((total - (valorParcela * (nr - 1))).toFixed(2)) : valorParcela,
          DOCUMENTO: 'CG' + this.modalCompraAnimais.abate.ID
        })
      }
      this.modalCompraAnimais.parcelas = parcelas
    },
    async onGerarResumoAnimais() {
      // Verifica se já existem animais na lista
      if (this.modalCompraAnimais.animais && this.modalCompraAnimais.animais.length > 0) {
        const confirmar = await this.$bvModal.msgBoxConfirm(
          `Já existem ${this.modalCompraAnimais.animais.length} animal(is) precificado(s) na lista. Deseja recriar a lista?`,
          {
            title: 'Recriar Lista de Animais',
            size: 'md',
            buttonSize: 'sm',
            okVariant: 'warning',
            okTitle: 'SIM, RECRIAR',
            cancelTitle: 'CANCELAR',
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true
          }
        )

        if (!confirmar) return
      }

      this.$store.commit('controle/setAguardando', true)
      try {
        await this.$http.post(`/api/protected/producao/processarResumoAnimaisArroba/${this.modalCompraAnimais.abate.ID}`)
        this.$root.$bvToast.toast('Resumo gerado com sucesso', { variant: 'success' })
        
        // Recarrega os dados do modal
        await this.abrirModalCompraAnimais({ ID: this.modalCompraAnimais.abate.ID })
      } catch (error) {
        this.$root.$bvToast.toast('Erro ao gerar resumo', { variant: 'danger' })
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    async onGerarTituloAPagar() {
      // Validação dos campos obrigatórios
      const camposObrigatorios = []
      
      if (!this.modalCompraAnimais.abate.OP_CREDOR || this.modalCompraAnimais.abate.OP_CREDOR.trim() === '') {
        camposObrigatorios.push('Comprar de Quem')
      }
      if (!this.modalCompraAnimais.abate.HISTORICO_APAGAR_ID) {
        camposObrigatorios.push('Histórico Caixa')
      }
      if (!this.modalCompraAnimais.abate.CENTRO_CUSTO_APAGAR_ID) {
        camposObrigatorios.push('Centro de Custo')
      }
      if (!this.modalCompraAnimais.abate.COMPRADOR_ID) {
        camposObrigatorios.push('Comprador')
      }
      if (!this.modalCompraAnimais.abate.VL_TOTAL_COMPRA || this.modalCompraAnimais.abate.VL_TOTAL_COMPRA <= 0) {
        camposObrigatorios.push('Valor Total da Compra')
      }
      if (!this.modalCompraAnimais.animais || this.modalCompraAnimais.animais.length === 0) {
        camposObrigatorios.push('Animais Precificados')
      }
      if (!this.modalCompraAnimais.parcelas || this.modalCompraAnimais.parcelas.length === 0) {
        camposObrigatorios.push('Parcelamento')
      }

      if (camposObrigatorios.length > 0) {
        this.$root.$bvToast.toast(
          `Preencha os seguintes campos obrigatórios: ${camposObrigatorios.join(', ')}`,
          { 
            title: 'Campos Obrigatórios', 
            variant: 'warning', 
            autoHideDelay: 5000,
            solid: true
          }
        )
        return
      }

      const confirmar = await this.$bvModal.msgBoxConfirm(
        `Deseja realmente gerar os títulos a pagar no valor de ${Number(this.modalCompraAnimais.abate.VL_TOTAL_COMPRA || 0).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})}?`,
        {
          title: 'Confirmação - Gerar Títulos a Pagar',
          size: 'md',
          buttonSize: 'sm',
          okVariant: 'success',
          okTitle: 'SIM, GERAR',
          cancelTitle: 'CANCELAR',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        }
      )

      if (!confirmar) return

      this.$store.commit('controle/setAguardando', true)
      try {
        const payload = {
          dados: {
            OP_CREDOR: this.modalCompraAnimais.abate.OP_CREDOR,
            HISTORICO_APAGAR_ID: this.modalCompraAnimais.abate.HISTORICO_APAGAR_ID,
            CENTRO_CUSTO_APAGAR_ID: this.modalCompraAnimais.abate.CENTRO_CUSTO_APAGAR_ID,
            COMPRADOR_ID: this.modalCompraAnimais.abate.COMPRADOR_ID,
            USUARIO: window.localStorage.getItem('login'),
            VL_TOTAL_COMPRA: this.modalCompraAnimais.abate.VL_TOTAL_COMPRA,
            ABATE_ID: this.modalCompraAnimais.abate.ID,
            PERCENTUAL_FUNRURAL: this.modalCompraAnimais.abate.PERCENTUAL_FUNRURAL,
            VL_FUNRURAL: this.modalCompraAnimais.abate.VL_FUNRURAL,
            VL_TOTAL_APAGAR: this.modalCompraAnimais.abate.VL_TOTAL_COMPRA
          },
          animaisPrecificados: this.modalCompraAnimais.animais,
          parcelas: this.modalCompraAnimais.parcelas
        }

        await this.$http.post('/api/protected/producao/gerarTitulo', payload)
        this.$root.$bvToast.toast('Títulos a pagar gerados com sucesso!', { variant: 'success', autoHideDelay: 3000 })
        
        // Recarrega os dados do modal
        await this.abrirModalCompraAnimais({ ID: this.modalCompraAnimais.abate.ID })
      } catch (error) {
        console.error('Erro ao gerar títulos:', error)
        this.$root.$bvToast.toast(
          error.response?.data || 'Erro ao gerar títulos a pagar',
          { variant: 'danger', autoHideDelay: 5000 }
        )
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    async onConfirmarCompraAnimais() {
      // Validação dos campos obrigatórios (sem validar parcelas)
      const camposObrigatorios = []
      
      if (!this.modalCompraAnimais.abate.OP_CREDOR || this.modalCompraAnimais.abate.OP_CREDOR.trim() === '') {
        camposObrigatorios.push('Comprar de Quem')
      }
      if (!this.modalCompraAnimais.abate.HISTORICO_APAGAR_ID) {
        camposObrigatorios.push('Histórico Caixa')
      }
      if (!this.modalCompraAnimais.abate.CENTRO_CUSTO_APAGAR_ID) {
        camposObrigatorios.push('Centro de Custo')
      }
      if (!this.modalCompraAnimais.abate.COMPRADOR_ID) {
        camposObrigatorios.push('Comprador')
      }
      if (!this.modalCompraAnimais.abate.VL_TOTAL_COMPRA || this.modalCompraAnimais.abate.VL_TOTAL_COMPRA <= 0) {
        camposObrigatorios.push('Valor Total da Compra')
      }
      if (!this.modalCompraAnimais.animais || this.modalCompraAnimais.animais.length === 0) {
        camposObrigatorios.push('Animais Precificados')
      }

      if (camposObrigatorios.length > 0) {
        this.$root.$bvToast.toast(
          `Preencha os seguintes campos obrigatórios: ${camposObrigatorios.join(', ')}`,
          { 
            title: 'Campos Obrigatórios', 
            variant: 'warning', 
            autoHideDelay: 5000,
            solid: true
          }
        )
        return
      }

      const confirmar = await this.$bvModal.msgBoxConfirm(
        `Deseja realmente confirmar a compra no valor de ${Number(this.modalCompraAnimais.abate.VL_TOTAL_COMPRA || 0).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})}?`,
        {
          title: 'Confirmação - Comprar Animais',
          size: 'md',
          buttonSize: 'sm',
          okVariant: 'success',
          okTitle: 'SIM, COMPRAR',
          cancelTitle: 'CANCELAR',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        }
      )

      if (!confirmar) return

      this.$store.commit('controle/setAguardando', true)
      try {
        const payload = {
          dados: {
            OP_CREDOR: this.modalCompraAnimais.abate.OP_CREDOR,
            HISTORICO_APAGAR_ID: this.modalCompraAnimais.abate.HISTORICO_APAGAR_ID,
            CENTRO_CUSTO_APAGAR_ID: this.modalCompraAnimais.abate.CENTRO_CUSTO_APAGAR_ID,
            COMPRADOR_ID: this.modalCompraAnimais.abate.COMPRADOR_ID,
            USUARIO: window.localStorage.getItem('login'),
            VL_TOTAL_COMPRA: this.modalCompraAnimais.abate.VL_TOTAL_COMPRA,
            ABATE_ID: this.modalCompraAnimais.abate.ID,
            PERCENTUAL_FUNRURAL: this.modalCompraAnimais.abate.PERCENTUAL_FUNRURAL,
            VL_FUNRURAL: this.modalCompraAnimais.abate.VL_FUNRURAL,
            VL_TOTAL_APAGAR: this.modalCompraAnimais.abate.VL_TOTAL_COMPRA
          },
          animaisPrecificados: this.modalCompraAnimais.animais
        }

        await this.$http.post('/api/protected/producao/comprar', payload)
        this.$root.$bvToast.toast('Compra confirmada com sucesso!', { variant: 'success', autoHideDelay: 3000 })
        
        // Recarrega os dados do modal
        await this.abrirModalCompraAnimais({ ID: this.modalCompraAnimais.abate.ID })
      } catch (error) {
        console.error('Erro ao confirmar compra:', error)
        this.$root.$bvToast.toast(
          error.response?.data || 'Erro ao confirmar a compra',
          { variant: 'danger', autoHideDelay: 5000 }
        )
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    async carregarDetalhes(item) {
      // Se já estiver aberto, fecha
      if (item._showDetails) {
        this.$set(item, '_showDetails', false)
        return
      }

      // Fecha outros detalhes abertos para manter a tela limpa
      this.lista.forEach(row => {
        if (row._showDetails) this.$set(row, '_showDetails', false)
      })

      this.$store.commit("ordemAbate/SET_REGISTRO_SELECIONADO_ID", item.ID)
      this.detalhes.loading = true
      this.$set(item, '_showDetails', true)
      
      try {
        const [resItens, resResumo] = await Promise.all([
          this.$http.get(`/api/protected/producao/getViewItensByAbateId/${item.ID}`),
          this.$http.get(`/api/protected/producao/getViewDetalheByAbateId/${item.ID}`)
        ])
        
        this.detalhes.animais.items = resItens.data
        this.detalhes.resumo.items = resResumo.data
      } catch (error) {
        console.error('Erro ao carregar detalhes:', error)
        this.$root.$bvToast.toast('Não foi possível carregar os detalhes da ordem.', {
          title: 'Erro',
          variant: 'danger',
          autoHideDelay: 3000
        })
      } finally {
        this.detalhes.loading = false
      }
    },
    onDetalhes (item) {
      this.$store.commit("ordemAbate/SET_REGISTRO_SELECIONADO_ID", item.ID)
      this.$store.commit('controle/setAguardando', true)
      this.$router.push(`/producao/ordemabate/detalhes/${item.ID}`)
    },
    async abrirModalPlanoExpedicao(item) {
      this.planoExpedicao.abateId = item.ID
      this.planoExpedicao.observacao = ''
      this.planoExpedicao.items = []
      this.planoExpedicao.existePedido = null
      this.planoExpedicao.mensagem = null
      this.planoExpedicao.busy = true
      this.$store.commit('controle/setAguardando', true)

      let errorToast = (message) => {
        this.$root.$bvToast.toast(message, {
          title: 'Falha',
          autoHideDelay: 4000,
          variant: 'warning',
          appendToast: true
        })
      }

      try {
        const response = await this.$http.get(`/api/protected/abate/listarItensNovoPlanoExpedicao/${item.ID}`)
        this.planoExpedicao.items = (response.data || []).map(row => ({
          ...row,
          selecionado: row.MARCA === '1'
        }))
      } catch (err) {
        const message = err?.response?.data || err?.message || err
        errorToast(`Falha ao carregar os itens do plano de expedição: ${message}`)
        this.planoExpedicao.busy = false
        this.$store.commit('controle/setAguardando', false)
        return
      }

      try {
        const existeResponse = await this.$http.get(`/api/protected/abate/getExistePedidoRetiradaServico/${item.ID}`)
        const existe = existeResponse.data && existeResponse.data.existe === true
        this.planoExpedicao.existePedido = existe
        if (existe === true) {
          this.planoExpedicao.mensagem = 'NÃO É POSSÍVEL ALTERAR O PLANO. JÁ EXISTE PEDIDO DE RETIRADA.'
        }
      } catch (err) {
        const message = err?.response?.data || err?.message || err
        this.planoExpedicao.existePedido = false
        this.planoExpedicao.mensagem = 'Não foi possível validar se já existe um pedido de retirada.'
        errorToast(`Falha ao validar o plano de expedição: ${message}`)
      } finally {
        this.planoExpedicao.busy = false
        this.$store.commit('controle/setAguardando', false)
        this.$refs['modal-plano-expedicao'].show()
      }
    },
    onMarcaPlanoAlteracao(item) {
      item.MARCA = item.selecionado ? '1' : '0'
    },
    rowClassPlanoExpedicao(item, type) {
      if (!item || type !== 'row') return
      if (item.OP_OBRIGATORIO === '1' && !item.selecionado) return 'table-warning'
    },
    async confirmarPlanoExpedicao() {
      if (this.confirmPlanoExpedicaoDisabled) {
        return
      }

      this.planoExpedicao.busy = true
      this.$store.commit('controle/setAguardando', true)
      const itensPayload = this.planoExpedicao.items.map(({ selecionado, ...rest }) => ({
        ...rest,
        MARCA: selecionado ? '1' : '0'
      }))
      const payload = {
        itens: itensPayload,
        observacao: this.planoExpedicao.observacao,
        usuario: window.localStorage.getItem('login')
      }

      try {
        await this.$http.post('/api/protected/abate/processarPlanoExpedicao/', payload)
        this.$root.$bvToast.toast('Plano de expedição processado com sucesso!', {
          title: 'Aviso',
          autoHideDelay: 3000,
          variant: 'success',
          appendToast: true
        })
        this.$refs['modal-plano-expedicao'].hide()
        this.planoExpedicao.items = []
        this.planoExpedicao.observacao = ''
        this.planoExpedicao.existePedido = null
        this.planoExpedicao.mensagem = null
      } catch (err) {
        const message = err?.response?.data || err?.message || err
        this.$root.$bvToast.toast(`Falha ao processar o plano de expedição: ${message}`, {
          title: 'Falha',
          autoHideDelay: 4000,
          variant: 'warning',
          appendToast: true
        })
      } finally {
        this.$store.commit('controle/setAguardando', false)
        this.planoExpedicao.busy = false
      }
    },
    onColetar (item) {
      this.$store.commit("ordemAbate/SET_REGISTRO_SELECIONADO_ID", item.ID)
      this.$store.commit('controle/setAguardando', true)
      this.$router.push(`/producao/ordemabate/coleta/${item.ID}`)
    },
    novo () {
      this.$router.push(`/producao/ordemabate/add`)
    },
    async pesquisar (ctx) {
      if (this.modalConfirmacaoAberto) {
        return
      }
      this.$store.commit('controle/setAguardando', true)
      
      const inputs = [this.$refs.dt1, this.$refs.dt2]
      inputs.forEach(input => {
        if (input && input.$el) input.$el.blur()
        else if (input && input.blur) input.blur()
      })

      this.$store
      .dispatch('ordemAbate/GERAR_LISTA')
      .then((result) => {
        this.$store.commit('controle/setAguardando', false)
        
        if (result && result.needsConfirmation) {
          this.resultadoPendente = result.data
          this.resultadoPendenteCount = result.count
          this.$refs.modalConfirmarResultadoGrande.show()
          return
        }

        this.status = true // or success
        return
      }).catch((error) => {
        this.$store.commit('controle/setAguardando', false)
        if (error) {
          this.status = false // or error
        }
      })
    },
    async confirmarCarregarResultadoGrande() {
      this.$store.commit('controle/setAguardando', true)
      try {
        await this.$store.dispatch('ordemAbate/GERAR_LISTA', { skipConfirmation: true })
        this.resultadoPendente = null
        this.resultadoPendenteCount = 0
      } catch (error) {
        this.$root.$bvToast.toast(`Falha ao carregar os registros: ${error.message}`, {
          title: 'Falha',
          autoHideDelay: 5000,
          variant: 'danger',
          appendToast: true
        })
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    cancelarCarregarResultadoGrande() {
      this.resultadoPendente = null
      this.resultadoPendenteCount = 0
    },
    onModalShown() {
      this.modalConfirmacaoAberto = true
    },
    onModalHidden() {
      this.modalConfirmacaoAberto = false
    },
    exportarHtml() {
      printHtmlReport({
        rows: this.lista,
        columns: this.fields.filter(f => f.key !== 'actions'),
        reportTitle: 'Listagem de Ordem de Abate',
        printedBy: window.localStorage.getItem('login') ?? '—',
        filename: 'ordem_abate.html',
      });
    },
    exportarExcel() {
      exportExcelXlsx({
        rows: this.lista,
        columns: this.fields.filter(f => f.key !== 'actions'),
        filename: 'ordem_abate.xlsx',
      });
    },
    exportarCsv() {
      exportCsv({
        rows: this.lista,
        columns: this.fields.filter(f => f.key !== 'actions'),
        filename: 'ordem_abate.csv',
      });
    },
    imprimir (id) {
      this.$store.commit('controle/setAguardando', true)
      this.$store.commit("ordemAbate/SET_REGISTRO_SELECIONADO_ID", id)
      let uri = `/api/protected/relatorios/producao/abate/${id}/${window.localStorage.getItem('login')}`
      this.$http.get(uri, {responseType: 'arraybuffer'})
        .then(response => {
          this.$store.commit('controle/setAguardando', false)
          const url = window.URL.createObjectURL(new Blob([response.data], {type: 'application/pdf'}))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'relAbate.pdf') 
          link.download = 'relAbate.pdf'
          // document.body.appendChild(link)
          //link.click()
          // document.body.removeChild(link)
          const janela = window.open(link)
          /*
          setTimeout(() =>
            { 
                janela.document.title = 'Relatório de Vendas'; 
            }, 1000);
            */
          
          janela.onload = function(){
            setTimeout(() => {
              janela.document.title = id +' Relatório de Ordem de Abate'
            }, 2000);
          }

          this.$root.$bvToast.toast(`Relatório Gerado com sucesso!!!`, {
            title: 'Aviso',
            autoHideDelay: 2000,
            variant: 'success',
            appendToast: true
          })
          
        })
        .catch(erro => {
          this.$store.commit('controle/setAguardando', false)
          Tools.exibirMensagem(this.$store, 'Erro', 'danger', 'Ocorreram erros ao gerar o Relatorio')
        })
    }
  },
  async created () {
    const listagem = this.$store.getters['ordemAbate/LISTA']
    if (!listagem.length) {
      await this.pesquisar()
    }

  },
  activated() {
    setTimeout(() => {
      if (this.$refs.edDT1 && typeof this.$refs.edDT1.focus === 'function') {
        this.$refs.edDT1.focus()
      }
    }, 300)
  },
  mounted() {
    setTimeout(() => {
      if (this.$refs.edDT1 && typeof this.$refs.edDT1.focus === 'function') {
        this.$refs.edDT1.focus()
      }
    }, 300)
  },
  watch: {
    'registro.OP_DEVEDOR' : function() {
      if (this.registro.OP_DEVEDOR == '0') {
        this.registro.campos.VL_SERVICO_CABECA = false
        this.registro.campos.NR_CABECAS = false
        this.registro.campos.DT_VENCIMENTO_ARECEBER = false
        this.registro.campos.HISTORICO_ARECEBER_ID = false
        this.registro.campos.CENTRO_CUSTO_ARECEBER_ID = false
      } else {
        this.registro.campos.VL_SERVICO_CABECA = true
        this.registro.campos.NR_CABECAS = true
        this.registro.campos.DT_VENCIMENTO_ARECEBER = true
        this.registro.campos.HISTORICO_ARECEBER_ID = true
        this.registro.campos.CENTRO_CUSTO_ARECEBER_ID = true
      }
    },
    'registro.VL_SERVICO_CABECA': function() {
      let cabecas = this.registro.NR_CABECAS
      let valor = this.registro.VL_SERVICO_CABECA
      this.registro.VL_TOTAL_SERVICO = parseFloat(cabecas * valor).toFixed(2)
    }
  }
}
</script>
<style>
  .compact-filter .custom-input-premium, 
  .compact-filter .custom-select-premium {
    padding: 0.15rem 0.4rem !important;
    height: 28px !important;
    font-size: 0.75rem !important;
  }

  .compact-filter label {
    margin-bottom: 0.05rem !important;
    font-size: 0.7rem !important;
    color: #64748b !important;
  }

  .compact-filter .cliente-pesquisa-wrapper .b-input-group {
    height: 28px !important;
  }

  .compact-filter .cliente-pesquisa-wrapper .autocomplete__inputs input {
    height: 26px !important;
    font-size: 0.75rem !important;
  }

  .compact-filter .cliente-pesquisa-wrapper .btn {
    height: 28px !important;
    min-height: 28px !important;
    padding: 0 0.4rem !important;
  }

  .compact-filter .cliente-pesquisa-wrapper .cec-pill-group .cec-pill-append .btn {
    height: 28px !important;
    min-height: 28px !important;
  }

  /* Checkbox/Switches compactos */
  .compact-filter .custom-switch-premium .custom-control {
    min-height: 1rem !important;
    padding-left: 2rem !important;
    margin-right: 0.4rem !important;
    margin-bottom: 0.2rem !important;
    display: inline-flex;
    align-items: center;
  }

  .compact-filter .custom-switch-premium .custom-control-label {
    font-size: 0.65rem !important;
    padding-top: 1px !important;
    line-height: 1.2 !important;
  }

  .compact-filter .custom-switch-premium .custom-control-label::before {
    height: 0.85rem !important;
    width: 1.5rem !important;
    top: 0.1rem !important;
  }

  .compact-filter .custom-switch-premium .custom-control-label::after {
    width: calc(0.85rem - 4px) !important;
    height: calc(0.85rem - 4px) !important;
    top: calc(0.1rem + 2px) !important;
  }

  badge-verde-clarinho {
    color: #fff;
    background-color: #f86c6b;
  }
  
  .b-table .my-left-border {
  border-left: 1px solid #a4b7c1;
  }
  .b-table .my-left-right {
    border-right: 1px solid #a4b7c1;
  }
  .b-table .my-left-bottom {
    border-bottom: 1px solid #a4b7c1;
  }
  
  /* Estilos para o Painel de Detalhes */
  .detail-card {
    transition: all 0.3s ease;
    overflow: hidden;
  }
  
  .detail-card:hover {
    box-shadow: 0 4px 12px rgba(0,0,0,0.1) !important;
  }
  
  .bg-soft-info {
    background-color: #e1f5fe;
  }
  
  .bg-soft-success {
    background-color: #e8f5e9;
  }
  
  .modern-premium-table.compact {
    font-size: 0.8rem;
  }
  
  .modern-premium-table.compact th,
  .modern-premium-table.compact td {
    padding: 0.4rem 0.6rem !important;
  }

  /* Responsividade do Header Premium */
  @media (max-width: 991px) {
    .search-pill-responsive {
      flex-wrap: wrap;
      border-radius: 1rem !important;
    }
    
    .date-inputs-responsive {
      flex-wrap: wrap;
      border-left: none !important;
      padding-left: 0 !important;
    }
    
    .btn-filtrar-responsive {
      width: 100%;
      margin-top: 0.5rem;
    }
  }

  @media (max-width: 767px) {
    .list-header-premium {
      gap: 1rem !important;
    }
    
    .search-pill-responsive {
      width: 100%;
      margin-right: 0 !important;
    }
    
    .btn-adicionar-responsive {
      width: 100%;
    }
  }

  @media (max-width: 575px) {
    .date-inputs-responsive .mx-1 {
      width: 120px !important;
      margin: 0.25rem !important;
    }
    
    .btn-filtrar-responsive .fa-search {
      margin-right: 0 !important;
    }
  }

  .bg-warning-light {
    background-color: #fff9c4 !important;
  }

  .custom-file-input:lang(pt) ~ .custom-file-label::after {
    content: 'Browsess';
  }
</style>



// WEBPACK FOOTER //
// src/views/producao/ordemabate/OrdemAbateListagem.vue